    // DASHBOARD FUNCTIONALITY
    // DOM Elements
    const dashboardPage = document.getElementById("DashboardPage");
    const influencerForm = document.getElementById("influencerForm");
    const contentForm = document.getElementById("contentSubmissionForm");
    const payoutForm = document.getElementById("payoutDetailsForm");
    const paymentForm = document.getElementById("paymentForm");
    const passwordForm = document.getElementById("ChangePasswordForm");

    // State variables
    let userEmail = null;
    let availableBalance = 0;
    let contentList = [];
    function initDashboard() {
        const user = getUserData();
        if (!user || !user.email) {
            window.location.href = "https://boltnutritions.com/pages/influencer-login";
            return;
        }

        userEmail = user.email;
        showElement(dashboardPage, true);
        window.refreshProfileImage?.();
        initContentForm();
        initPayoutForm();
        initPaymentForm();

        setTimeout(()=>{
        loadInfluencerContentAndStatus(); 
        },1200)

        initChangePasswordForm();
        initLogoutButton();
    }
    document.addEventListener("DOMContentLoaded", () => {
        const infCodeEl = document.getElementById("infCodes");
        const expiryNoteEl = document.getElementById("infExpiryNote");
        const welcomeHeading = document.getElementById("welcomeHeading");
        const copyBtn = document.getElementById("copyInfCodeChip");

        const setExpiryNote = (createdAt) => {
            if (!createdAt || !expiryNoteEl) return;

            const created = new Date(createdAt);
            const expiry = new Date(created);
            expiry.setDate(expiry.getDate() + 30);

            const today = new Date();
            today.setHours(0, 0, 0, 0);
            expiry.setHours(0, 0, 0, 0);

            const daysLeft = Math.ceil((expiry - today) / 86400000);

            expiryNoteEl.className = `fw-bold ${daysLeft > 0 ? "text-warning" : "text-danger"}`;
            expiryNoteEl.textContent =
                daysLeft > 0
                    ? `NOTE: Code expires in ${daysLeft} day${daysLeft > 1 ? "s" : ""}`
                    : "NOTE: Code has expired";
        };

        const copyToClipboard = async (text) => {
            try {
                if (navigator.clipboard && window.isSecureContext) {
                    await navigator.clipboard.writeText(text);
                } else {
                    const ta = document.createElement("textarea");
                    ta.value = text;
                    ta.style.position = "fixed";
                    ta.style.opacity = "0";
                    document.body.appendChild(ta);
                    ta.select();
                    document.execCommand("copy");
                    document.body.removeChild(ta);
                }
                return true;
            } catch {
                return false;
            }
        };

        if (copyBtn && infCodeEl) {
            copyBtn.addEventListener("click", async function () {
                const code = infCodeEl.innerText.trim();
                if (!code || code === "Under Review") return;

                const icon = this.querySelector("i");
                if (await copyToClipboard(code)) {
                    this.classList.add("copied");
                    icon?.classList.replace("bi-copy", "bi-check-lg");

                    setTimeout(() => {
                        this.classList.remove("copied");
                        icon?.classList.replace("bi-check-lg", "bi-copy");
                    }, 1400);
                }
            });
        }

        const loadInfluencerCode = async () => {
            if (!infCodeEl) return;

            const user = JSON.parse(localStorage.getItem("user") || "{}");
            if (!user.email) {
                infCodeEl.textContent = "Under Review";
                expiryNoteEl && (expiryNoteEl.textContent = "");
                return;
            }

            try {
                const res = await fetch("https://collab.boltnutritions.com/api/bind-influencer-campaign");
                if (!res.ok) throw new Error();
                const { success, data } = await res.json();

                let infCode = "Under Review";

                if (success && Array.isArray(data)) {
                    const campaign = data.find(
                        i => i.email?.toLowerCase() === user.email.toLowerCase()
                    );

                    if (campaign) {
                        infCode = campaign.inf_code || campaign.inf_no || "Under Review";
                        campaign.created_at && setExpiryNote(campaign.created_at);

                        if (welcomeHeading) {
                            welcomeHeading.textContent =
                                `Welcome Back, ${campaign.first_name || "BOLT"}!`;
                        }
                    }
                }

                infCodeEl.textContent = infCode;
            } catch {
                infCodeEl.textContent = "Under Review";
            }
        };

        loadInfluencerCode();
    });

    (async function fetchInfCode() {
        try {
            const user = JSON.parse(localStorage.getItem("user") || "{}");

            if (!user.email) {
                console.warn("INF CODE: User not logged in");
                return;
            }

            const userRes = await fetch(
                `https://collab.boltnutritions.com/api/check-user?email=${encodeURIComponent(user.email)}`
            );
            const userData = await userRes.json();

            const campaignRes = await fetch(
                `https://collab.boltnutritions.com/api/bind-influencer-campaign`
            );
            const campaignData = await campaignRes.json();

            let infCode = "Under Review";
            let infNo = "";

            if (userData.success && userData.user) {
                const { inf_code, inf_no } = userData.user;
                if (inf_code || inf_no) {
                    infCode = inf_code || inf_no;
                    infNo = inf_no || "";
                }
                
                localStorage.setItem(
                    "infCode",
                    JSON.stringify({ inf_code, inf_no })
                );
            }

            if (campaignData.success && campaignData.data && Array.isArray(campaignData.data)) {
                const userCampaign = campaignData.data.find(item => 
                    item.email && item.email.toLowerCase() === user.email.toLowerCase()
                );
                
                if (userCampaign && (userCampaign.inf_code || userCampaign.inf_no)) {
                    infCode = userCampaign.inf_code || userCampaign.inf_no;
                    infNo = userCampaign.inf_no || infNo;
                }
            }
            const infCodeEl = document.getElementById("infCode");
            if (infCodeEl) {
                infCodeEl.textContent = infCode;
                
                if (infCode === "Under Review") {
                    infCodeEl.classList.add("under-review");
                }
            }
            if (userData.success && userData.user) {
                fillPaymentTable(userData.user);
            }

        } catch (err) {
            console.error("INF CODE ERROR:", err);
            const infCodeEl = document.getElementById("infCode");
            if (infCodeEl) {
                infCodeEl.textContent = "Under Review";
                infCodeEl.classList.add("under-review");
            }
        }
    })();

    function fillProfileData(profile) {
        if (!profile) return;
        const fields = {
            'name': `${profile.first_name || ""} ${profile.last_name || ""}`.trim(),
            'email': profile.email || "",
            'phone': profile.mobile || "",
            'instagram': profile.instagram_profile || "",
            'followers': profile.followers || "",
            'category': profile.category || "",
            'address': `${profile.city || ""}, ${profile.state || ""}`.trim()
        };

        Object.entries(fields).forEach(([id, value]) => {
            const element = document.getElementById(id);
            if (element) element.value = value;
        });

        const heading = document.querySelector("#DashboardPage #welcomeHeading");
        if (heading) {
            heading.textContent = `Welcome Back, ${profile.first_name || "User"}!`;
        }

        const onbordngData = document.querySelector(".onbording");
        if (onbordngData) {
            if (!profile.onboarded_for || profile.onboarded_for.trim() === "") {
                onbordngData.innerHTML = `<span class="badge bg-danger text-white border border-danger-subtle px-3 py-1">Draft</span>`;
            } else {
                onbordngData.innerHTML = `<span class="badge bg-success text-white border border-success-subtle px-3 py-1">Active</span>`;
            }
        }
    }

    function fillPaymentTable(profile) {
        document.querySelector("#displayAccHolder").value = profile?.account_holder || "";
        document.querySelector("#displayBankName").value = profile?.bank_name || "";
        document.querySelector("#displayAccNumber").value = profile?.account_number || "";
        document.querySelector("#displayIfscCode").value = profile?.ifsc || "";
    }
    document.addEventListener('DOMContentLoaded', function() {
        const editButton = document.getElementById('editBankDetailsBtn');
        const formSection = document.getElementById('payoutFormSection');
        const closeButton = document.getElementById('closeFormBtn');
        const receivingAccountSection = document.getElementById('receivingAccountSection');
        
        editButton.addEventListener('click', function() {
            receivingAccountSection.classList.add('d-none');
            formSection.classList.remove('d-none');
            document.getElementById('bankStatus').textContent = 'Editing';
            document.getElementById('bankStatus').className = 'badge bg-info text-dark px-3 py-2';
        });
        
        closeButton.addEventListener('click', function() {
            formSection.classList.add('d-none');
            receivingAccountSection.classList.remove('d-none');
            document.getElementById('bankStatus').textContent = 'Setup Complete';
            document.getElementById('bankStatus').className = 'badge bg-warning text-dark px-3 py-2';
        });
    });

    function updateDashboardUI(profile, contentList) {
        const verifyCheck = document.getElementById("verifyCheck");
        const contentStatusBadge = document.getElementById("contentStatus");
        const lastContent = contentList.at(-1);
        const lastStatus = lastContent?.ContentStatus || "Not Submitted";

        if (verifyCheck) verifyCheck.textContent = lastStatus;
        if (contentStatusBadge) contentStatusBadge.textContent = lastStatus;
        updatePaymentButton(contentList);
    }

    const userData = JSON.parse(localStorage.getItem("user") || "{}");
    fillProfileForm(userData.email);

    influencerForm.addEventListener("submit", async (e) => {
        e.preventDefault();

        const saveBtn = influencerForm.querySelector('button[type="submit"]');
        if (!saveBtn) return;

        if (!userData?.email) {
            alert("User not logged in");
            return;
        }

        saveBtn.disabled = true;
        const originalText = saveBtn.textContent;
        saveBtn.textContent = "Saving...";

        try {
            const fullName = document.getElementById("name")?.value.trim() || "";
            const [first_name, ...lastParts] = fullName.split(" ");
            const last_name = lastParts.join(" ");

            const payload = {
                action: "updateprofile",
                email: userData.email,
                first_name,
                last_name,
                name: fullName,
                mobile: document.getElementById("phone")?.value.trim() || "",
                instagram_profile: document.getElementById("instagram")?.value.trim() || "",
                followers: document.getElementById("followers")?.value.trim() || "",
                onboard_type: document.getElementById("category")?.value || "",
                address: document.getElementById("address")?.value.trim() || ""
            };

            const res = await fetch("https://collab.boltnutritions.com/api/influencers", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            });

            if (!res.ok) {
                throw new Error(`HTTP error! Status: ${res.status}`);
            }

            const data = await res.json();

            if (!data.success) {
                throw new Error(data.message || "Update failed");
            }

            alert("Profile updated successfully!");

            // Update localStorage
            localStorage.setItem("user", JSON.stringify({
                ...userData,
                ...payload
            }));

            // Refresh UI
            fillProfileForm(userData.email);
            window.refreshProfileImage?.();

        } catch (err) {
            console.error("Update Error:", err);
            alert("Something went wrong. Please try again.");
        } finally {
            saveBtn.disabled = false;
            saveBtn.textContent = originalText;
        }
    });
    
    let influencerDataCache = null;
    let contentFormInitialized = false;

    async function getInfluencerData(email) {
        if (influencerDataCache) return influencerDataCache;

        const url = `https://collab.boltnutritions.com/api/influencers${email ? '?email=' + encodeURIComponent(email) : ''}`;
        const res = await fetch(url);
        const data = await res.json();

        influencerDataCache = data;
        return data;
    }

   function initContentForm() {
    if (!contentForm || contentFormInitialized) return;
    contentFormInitialized = true;

    const titleInput = document.getElementById('contentTitle');
    const urlInput = document.getElementById('contentUrl');
    const urlHint = document.getElementById('urlHint');
    const urlIcon = document.getElementById('urlIcon');
    const contentTypeRadios = document.querySelectorAll('input[name="content_type"]');
    
    const urlPlaceholders = {
        'reel': 'https://www.instagram.com/reel/Cxample123...',
        'story': 'https://www.instagram.com/stories/username/Cxample123...',
        'static': 'https://www.instagram.com/p/Cxample123...'
    };
    
    const urlHints = {
        'reel': 'Paste the full Instagram Reel URL',
        'story': 'Paste the full Instagram Story URL',
        'static': 'Paste the full Instagram Post URL'
    };
    
    const urlIcons = {
        'reel': 'bi-play-circle',
        'story': 'bi-card-image',
        'static': 'bi-image'
    };
    
    const typeSuffixes = {
        'reel': ' (Reel)',
        'story': ' (Story)',
        'static': ' (Post)'
    };
    
    function updateUrlFieldForContentType(type) {
        urlInput.placeholder = urlPlaceholders[type] || urlPlaceholders.reel;        
        urlHint.textContent = urlHints[type] || urlHints.reel;
        urlIcon.className = 'bi ' + urlIcons[type] + ' text-primary';
    }
    
    function detectContentTypeFromUrl(url) {
        const urlLower = url.toLowerCase();
        
        if (urlLower.includes('/reel/')) {
            return 'reel';
        } else if (urlLower.includes('/stories/') || urlLower.includes('/story/')) {
            return 'story';
        } else if (urlLower.includes('/p/') || urlLower.includes('/tv/')) {
            return 'static';
        }
        return null;
    }
    
    function appendTypeSuffixToTitle(type) {
        const currentTitle = titleInput.value.trim();
        const suffix = typeSuffixes[type];
        
        if (!currentTitle) return;
        
        let cleanTitle = currentTitle;
        Object.values(typeSuffixes).forEach(existingSuffix => {
            if (cleanTitle.endsWith(existingSuffix)) {
                cleanTitle = cleanTitle.slice(0, -existingSuffix.length).trim();
            }
        });
        
        titleInput.value = cleanTitle + suffix;
    }
    
    function handleUrlChange() {
        const url = urlInput.value;
        const detectedType = detectContentTypeFromUrl(url);
        
        if (detectedType) {
            const radioId = `contentType${detectedType.charAt(0).toUpperCase() + detectedType.slice(1)}`;
            const radio = document.getElementById(radioId);
            if (radio) {
                radio.checked = true;
            }
            
            updateUrlFieldForContentType(detectedType);
            
            if (titleInput.value.trim()) {
                appendTypeSuffixToTitle(detectedType);
            }
        }
    }
    
    contentTypeRadios.forEach(radio => {
        radio.addEventListener('change', function() {
            if (this.checked) {
                updateUrlFieldForContentType(this.value);
                
                if (titleInput.value.trim()) {
                    appendTypeSuffixToTitle(this.value);
                }
            }
        });
    });
    
    urlInput.addEventListener('input', handleUrlChange);
    
    titleInput.addEventListener('blur', function() {
        const url = urlInput.value;
        if (url) {
            const detectedType = detectContentTypeFromUrl(url);
            if (detectedType && titleInput.value.trim()) {
                appendTypeSuffixToTitle(detectedType);
            }
        }
    });
    
    // Initialize with today's date and reel as default
    const today = new Date().toISOString().split('T')[0];
    document.getElementById('contentDate').value = today;    
    updateUrlFieldForContentType('reel');
    
    // MODIFIED SUBMISSION HANDLER WITH CAMPAIGN CHECK
    contentForm.addEventListener("submit", async (e) => {
        e.preventDefault();
        if (!userEmail) {
            alert('Please login first');
            return;
        }

        const submitBtn = contentForm.querySelector('button[type="submit"]');
        submitBtn.disabled = true;
        submitBtn.textContent = "Checking eligibility...";

        try {
            // STEP 1: Check if influencer exists in campaign API
            const campaignRes = await fetch("https://collab.boltnutritions.com/api/bind-influencer-campaign");
            
            if (!campaignRes.ok) {
                throw new Error("Failed to check campaign eligibility");
            }
            
            const campaignData = await campaignRes.json();
            
            // Check if user exists in campaign data
            let isEligible = false;
            let campaignInfo = null;
            
            if (campaignData.success && Array.isArray(campaignData.data)) {
                campaignInfo = campaignData.data.find(
                    item => item.email?.toLowerCase() === userEmail.toLowerCase()
                );
                
                isEligible = !!campaignInfo; // True if campaignInfo exists
            }
            
            if (!isEligible) {
                alert('You are not eligible to submit content. Please complete your campaign onboarding first or contact support.');
                submitBtn.disabled = false;
                submitBtn.textContent = "Verify Content";
                return;
            }
            
            // STEP 2: Continue with content submission if eligible
            submitBtn.textContent = "Verifying...";
            
            // Get form values including content_type
            const title = document.getElementById("contentTitle").value.trim();
            const url = document.getElementById("contentUrl").value.trim();
            const date = document.getElementById("contentDate").value;
            const contentType = document.querySelector('input[name="content_type"]:checked')?.value || 'reel';
            
            // Basic validation
            if (!title || !url || !date) {
                alert('Please fill in all required fields');
                submitBtn.disabled = false;
                submitBtn.textContent = "Verify Content";
                return;
            }
            
            const urlPattern = /^https?:\/\/.+\..+/;
            if (!urlPattern.test(url)) {
                alert('Please enter a valid URL');
                submitBtn.disabled = false;
                submitBtn.textContent = "Verify Content";
                return;
            }

            const newContent = {
                title: title,
                url: url,
                date_created: date,
                content_type: contentType,
                ContentStatus: "Pending",
                campaign_id: campaignInfo?.id || null, // Optional: store campaign ID
                campaign_name: campaignInfo?.campaign_name || null // Optional: store campaign name
            };

            const data = await getInfluencerData(userEmail);

            let existingContents = Array.isArray(data?.user?.contents)
                ? data.user.contents
                : [];

            const duplicate = existingContents.find(c => c.title === newContent.title);
            let forceUpdate = false;

            if (duplicate) {
                const ok = confirm("This content already exists. Overwrite?");
                if (!ok) {
                    submitBtn.disabled = false;
                    submitBtn.textContent = "Verify Content";
                    return;
                }
                forceUpdate = true;
                existingContents = existingContents.map(c =>
                    c.title === newContent.title ? newContent : c
                );
            } else {
                existingContents.push(newContent);
            }

            const payload = {
                email: userEmail,
                forceUpdate,
                contents: existingContents
            };

            const saveRes = await fetch("https://collab.boltnutritions.com/api/influencers", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            });

            const saveData = await saveRes.json();
            influencerDataCache = null;

            if (saveData.success) {
                const typeLabels = {
                    'reel': 'Reel',
                    'story': 'Story',
                    'static': 'Post'
                };
                alert(`✅ Content submitted successfully!\n\n${title}`);
                contentForm.reset();
                document.getElementById('contentDate').value = today;
                updateUrlFieldForContentType('reel');
                renderContentTable(existingContents, saveData.poc_check);
            } else {
                alert(saveData.message || "Failed to submit content");
            }
        } catch (err) {
            console.error("Content submission error:", err);
            alert("Server error. Please try again later.");
        } finally {
            submitBtn.disabled = false;
            submitBtn.textContent = "Verify Content";
        }
    });
}

    const loggedInEmail = getUserData()?.email;

    async function loadInfluencerContentAndStatus() {
        try {
            const res = await fetch(`https://collab.boltnutritions.com/api/check-user?email=${encodeURIComponent(loggedInEmail)}`);
            const json = await res.json();

            if (!json.success) {
                console.error("API failed");
                return;
            }

            const contents = json.contents || [];
            const infNo = json?.user?.inf_no;

            const influencerData = await getInfluencerData();
            const poc = influencerData?.poc_check?.find(p => p.inf_no === infNo);

            updateTopStatusBadge(poc);
            renderContentTable(contents, poc);
        } catch (err) {
            console.error("API error:", err);
        }
    }

    function updateTopStatusBadge(pocData) {
        const badge = document.getElementById("influencerStatusBadge");

        let text = "Pending";
        let color = "bg-warning";

        if (pocData) {
            if (pocData.Approved_by_POC === "Approved") {
                text = "Approved";
                color = "bg-success";
            } else if (pocData.Approved_by_POC === "Rejected") {
                text = "Rejected";
                color = "bg-danger";
            }
        }

        badge.className = `badge ${color} px-3 py-2`;
        badge.style.fontSize = "0.75rem";
        badge.style.borderRadius = "4px";
        badge.textContent = text;
    }

    function renderContentTable(contentList, pocData, infData) {
        contentTableBody.innerHTML = "";

        if (!contentList.length) {
            contentTableBody.innerHTML = `
                <tr>
                    <td colspan="4" class="text-center text-muted">
                        No content submitted yet
                    </td>
                </tr>`;
            return;
        }

        let statusText = "Pending";
        let statusClass = "bg-warning";

        if (pocData) {
            if (pocData.Approved_by_POC === "Approved") {
                statusText = "Approved";
                statusClass = "bg-success";
            } else if (pocData.Approved_by_POC === "Rejected") {
                statusText = "Rejected";
                statusClass = "bg-danger";
            }
        }

        contentList.forEach(item => {
            contentTableBody.insertAdjacentHTML("beforeend", `
                <tr>
                    <td>${item.title}</td>
                    <td>
                        <a href="${item.url}" target="_blank">View Content</a>
                    </td>
                    <td>${new Date(item.created_at)?.toLocaleDateString("en-GB") || item.created_at}</td>
                    <td class="text-end">
                        <span class="badge ${statusClass}">
                            ${statusText}
                        </span>
                    </td>
                </tr>
            `);
        });
    }

   let payoutFormInitialized = false;
function initPayoutForm() {
    if (payoutFormInitialized) return;
    payoutFormInitialized = true;
    const form = document.getElementById('payoutDetailsForm');
    if (!form) return;

    let originalAccountNumber = '';
    let isAccountNumberValid = false;

    // DOM elements
    const elements = {
        accountNumber: document.getElementById('accountNumber'),
        confirmAccountNumber: document.getElementById('confirmAccountNumber'),
        accountHolder: document.getElementById('accountHolder'),
        bankName: document.getElementById('bankName'),
        ifscCode: document.getElementById('ifscCode'),
        agreeTerms: document.getElementById('agreeTerms'),
        bankStatus: document.getElementById('bankStatus'),
        accountNumberIndicator: document.getElementById('accountNumberIndicator'),
        bankFields: document.getElementById('bankFields')
    };

    const validators = {
        accountNumber: (value) => /^\d{9,18}$/.test(value),
        ifsc: (value) => /^[A-Z]{4}0[A-Z0-9]{6}$/i.test(value)
    };

    const uiHelpers = {
        setIndicator: (indicator, status) => {
            const states = {
                valid: { text: '✓', color: 'green', show: true },
                invalid: { text: '✗', color: 'red', show: true },
                pending: { text: '*', color: 'orange', show: true }
            };
            
            if (states[status]) {
                indicator.textContent = states[status].text;
                indicator.style.color = states[status].color;
                indicator.style.fontWeight = 'bold';
                indicator.classList.remove('d-none');
            } else {
                indicator.classList.add('d-none');
            }
        },
        
        setValidation: (element, isValid) => {
            element.classList.toggle('is-invalid', !isValid);
        }
    };

    function validateAccountNumber() {
        const accNum = elements.accountNumber.value.trim();
        const confirmAccNum = elements.confirmAccountNumber.value.trim();
        
        let actualAccNum = (accNum.includes('•') && originalAccountNumber) 
            ? originalAccountNumber 
            : accNum.replace(/\D/g, '');
        
        const confirmActual = confirmAccNum.replace(/\D/g, '');
        
        uiHelpers.setIndicator(elements.accountNumberIndicator, null);
        uiHelpers.setValidation(elements.accountNumber, true);
        uiHelpers.setValidation(elements.confirmAccountNumber, true);
        
        if (!actualAccNum) {
            isAccountNumberValid = false;
            return false;
        }
        
        if (!validators.accountNumber(actualAccNum)) {
            uiHelpers.setValidation(elements.accountNumber, false);
            uiHelpers.setIndicator(elements.accountNumberIndicator, 'invalid');
            isAccountNumberValid = false;
            return false;
        }
        
        if (confirmActual && actualAccNum !== confirmActual) {
            uiHelpers.setValidation(elements.confirmAccountNumber, false);
            uiHelpers.setIndicator(elements.accountNumberIndicator, 'invalid');
            isAccountNumberValid = false;
            return false;
        }
        
        if (actualAccNum && confirmActual && actualAccNum === confirmActual) {
            uiHelpers.setIndicator(elements.accountNumberIndicator, 'valid');
            isAccountNumberValid = true;
            return true;
        }
        
        uiHelpers.setIndicator(elements.accountNumberIndicator, 'pending');
        isAccountNumberValid = false;
        return false;
    }

    // Masking functions
    function maskAccountNumber() {
        const accNum = elements.accountNumber.value.replace(/\D/g, '');
        
        if (validators.accountNumber(accNum)) {
            originalAccountNumber = accNum;
            const maskedLength = Math.min(accNum.length, 12);
            elements.accountNumber.value = '•'.repeat(maskedLength);
            validateAccountNumber();
        } else if (accNum) {
            elements.accountNumber.classList.add('is-invalid');
        }
    }

    function unmaskAccountNumber() {
        if (elements.accountNumber.value.includes('•') && originalAccountNumber) {
            elements.accountNumber.value = originalAccountNumber;
        }
    }

    function loadPayoutDetails() {
        try {
            const user = JSON.parse(localStorage.getItem("userProfile") || "{}");

            if (!user || !user.email) {
                console.warn("User payout data not available yet");
                return;
            }

            elements.accountHolder.value = user.account_holder || '';
            elements.bankName.value = user.bank_name || '';
            elements.ifscCode.value = user.ifsc || '';
            elements.confirmAccountNumber.value = '';

            if (user.account_number) {
                originalAccountNumber = user.account_number;
                elements.accountNumber.value = '•'.repeat(
                    Math.min(user.account_number.length, 12)
                );
            } else {
                elements.accountNumber.value = '';
            }

            elements.bankStatus.textContent =
                user.account_holder ? 'Setup Complete' : 'Setup Required';

            if (user.account_number) validateAccountNumber();

        } catch (err) {
            console.error("Failed to load payout details:", err);
        }
    }

    async function handleSubmit(e) {
        e.preventDefault();
        
        if (!elements.agreeTerms.checked) {
            alert('Please confirm that all details are accurate.');
            elements.agreeTerms.focus();
            return;
        }
        
        const user = getUserData();
        if (!user?.email) {
            alert('User not logged in');
            return;
        }
        
        if (!elements.accountHolder.value.trim()) {
            alert('Account Holder Name is required');
            return;
        }
        if (!elements.bankName.value) {
            alert('Please select your bank');
            return;
        }
        if (!isAccountNumberValid) {
            alert('Please make sure account numbers match.');
            elements.confirmAccountNumber.focus();
            return;
        }
        if (!validators.ifsc(elements.ifscCode.value)) {
            alert('Invalid IFSC Code format.');
            return;
        }
        
        const payload = {
            action: 'savebank',
            email: user.email,
            account_holder: elements.accountHolder.value.trim().toUpperCase(),
            bank_name: elements.bankName.value,
            account_number: originalAccountNumber,
            ifsc: elements.ifscCode.value.trim()
        };
        
        const btn = document.getElementById('savePayoutDetails');
        if (!btn) return;
        
        setButtonLoading(btn, true);
        
        try {
            const res = await fetch('https://collab.boltnutritions.com/api/influencers', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            
            const data = await res.json();
            
            if (data.success) {
                elements.bankStatus.textContent = 'Setup Complete';
                alert('Bank details saved successfully!');
                await loadPayoutDetails();
            } else {
                alert('Failed: ' + (data.message || 'Unknown error'));
            }
        } catch (err) {
            console.error(err);
            alert('Error saving bank details');
        } finally {
            resetButton(btn);
        }
    }

    function initEventListeners() {
        elements.accountNumber.addEventListener('focus', unmaskAccountNumber);
        elements.accountNumber.addEventListener('blur', maskAccountNumber);
        elements.accountNumber.addEventListener('input', () => {
            if (!elements.accountNumber.value.includes('•')) {
                validateAccountNumber();
            }
        });
        
        elements.confirmAccountNumber.addEventListener('input', validateAccountNumber);
        
        elements.accountHolder.addEventListener('input', () => {
            elements.accountHolder.value = elements.accountHolder.value.toUpperCase();
        });
        
        form.addEventListener('submit', handleSubmit);
    }

    loadPayoutDetails();
    initEventListeners();
}

    //fillPaymentData
    function fillPaymentData(profile) {
        if (!profile) return;
        
        document.getElementById("accountHolder").value = profile?.AccountHolder || "";
        document.getElementById("bankName").value = profile?.BankName || "";
        document.getElementById("accountNumber").value = profile?.AccountNumber || "";
        document.getElementById("ifscCode").value = profile?.IFSC || "";
        document.getElementById("upiId").value = profile?.UPI || "";

        const bankStatusBadge = document.getElementById("bankStatus");
        if (bankStatusBadge) {
            const hasDetails = profile?.AccountHolder || profile?.UPI;
            bankStatusBadge.textContent = hasDetails ? "Setup Complete" : "Setup Required";
        }

        // Payment method selection
        if (profile?.UPI) {
            document.getElementById("methodUPI").checked = true;
        } else {
            document.getElementById("methodBank").checked = true;
        }
        togglePayoutFields();

        // Available Balance
        availableBalance = Number(profile.AvailableBalance || 15000);
        const availableBalanceEl = document.getElementById("availableBalance");
        if (availableBalanceEl) {
            availableBalanceEl.textContent = `₹${availableBalance.toLocaleString("en-IN", { 
                minimumFractionDigits: 2, 
                maximumFractionDigits: 2 
            })}`;
        }
        updatePaymentButton(contentList);
    }

    // Initialize payment form
    function initPaymentForm() {
        if (!paymentForm) return;

    function calculateNetAmount() {
        const amount = Number(document.getElementById("paymentAmount")?.value || 0);
        const fee = amount * 0.02;
        const net = amount - fee;

        const processingFeeEl = document.getElementById("processingFee");
        const netAmountEl = document.getElementById("netAmount");

        if (processingFeeEl) processingFeeEl.textContent = `- ₹${fee.toFixed(2)}`;
        if (netAmountEl) netAmountEl.textContent = `₹${net.toFixed(2)}`;
    }

    document.getElementById("paymentAmount")?.addEventListener("input", calculateNetAmount);
    }

    let influencerDataCache2 = null;

    const influencerApi = async () => {
        if (influencerDataCache2) return influencerDataCache2;

        try {
            const url = 'https://collab.boltnutritions.com/api/influencers';
            const res = await fetch(url);

            if (!res.ok) {
                throw new Error('Failed to fetch influencers');
            }

            const data = await res.json();
            influencerDataCache2 = data; // cache it
            return data;
        } catch (err) {
            console.error('Influencer API Error:', err);
        }
    };

    async function fillProfileForm(email) {
        try {
            const res = await fetch(
                `https://collab.boltnutritions.com/api/check-user?email=${encodeURIComponent(email)}`
            );
            const data = await res.json();

            if (!data.success || !data.user) return;

            const user = data.user;

            renderContentTable(data.contents);

            const infData = await influencerApi(); // await it once if needed
            // console.log(infData, "Influencer API Data");

            document.getElementById("name").value =
                `${user.first_name || ""} ${user.last_name || ""}`.trim();
            document.getElementById("email").value = user.email || "";
            document.getElementById("phone").value = user.mobile || "";
            document.getElementById("instagram").value = user.instagram_profile || "";
            document.getElementById("followers").value = user.followers || "";
            document.getElementById("address").value =
                `${user.city || ""}, ${user.state || ""}`.trim();

            const categorySelect = document.getElementById("category");
            if (categorySelect && user.onboard_type) {
                const optionExists = [...categorySelect.options].some(
                    opt => opt.value === user.onboard_type
                );
                if (optionExists) {
                    categorySelect.value = user.onboard_type;
                    categorySelect.disabled = true;
                }
            }

            const onboardingData = document.querySelector(".onbording");
            if (onboardingData) {
                onboardingData.innerHTML = user.onboard_type
                    ? `<span class="badge bg-success text-white px-3 py-1">Active</span>`
                    : `<span class="badge bg-danger text-white px-3 py-1">Draft</span>`;
            }

            const heading = document.querySelector("#DashboardPage #welcomeHeading");
            if (heading) {
                heading.textContent = `Welcome Back, ${user.first_name || ""}!`;
            }

            localStorage.setItem(
                "userProfile",
                JSON.stringify({
                    id: user.id,
                    inf_no: user.inf_no,
                    first_name: user.first_name,
                    last_name: user.last_name,
                    email: user.email,
                    mobile: user.mobile,
                    instagram_profile: user.instagram_profile,
                    followers: user.followers,
                    onboard_type: user.onboard_type,
                    address: user.address,
                    city: user.city,
                    state: user.state,
                    created_at: user.created_at
                })
            );

        } catch (err) {
            console.error("Failed to load profile", err);
        }
    }

    // Payment or Bank details saving on table  | switch payments 
    document.querySelectorAll('.bank-details-section button[data-bs-toggle="pill"]').forEach(button => {
        button.addEventListener('click', function (event) {
            event.preventDefault();
            const parentList = this.closest('.nav-pills');
            parentList.querySelectorAll('.nav-link').forEach(btn => btn.classList.remove('active'));
            this.classList.add('active');
            const targetId = this.getAttribute('data-bs-target');
            const contentContainer = document.querySelector('#paymentMethodContent');
            contentContainer.querySelectorAll('.tab-pane').forEach(pane => {
                pane.classList.remove('show', 'active');
            });
            const targetPane = document.querySelector(targetId);
            targetPane.classList.add('show', 'active');
        });
    });

    // Initialize change password form
    let passwordListenerAttached = false;
    function initChangePasswordForm() {
        if (!passwordForm || passwordListenerAttached) return;

        passwordListenerAttached = true;

        passwordForm.addEventListener("submit", async function (e) {
            e.preventDefault();

            const user = getUserData();
            if (!user || !user.email) {
                showPasswordMessage("Please login first", "error");
                return;
            }

            const currentPassword = document.getElementById("CurrentPassword").value.trim();
            const newPassword = document.getElementById("NewPassword").value.trim();
            const confirmPassword = document.getElementById("ConfirmPassword").value.trim();

            if (!currentPassword || !newPassword || !confirmPassword) {
                showPasswordMessage("Please fill in all password fields", "error");
                return;
            }

            if (newPassword !== confirmPassword) {
                showPasswordMessage("New passwords do not match", "error");
                return;
            }

            if (newPassword.length < 6) {
                showPasswordMessage("New password must be at least 6 characters", "error");
                return;
            }

            const submitBtn = passwordForm.querySelector('button[type="submit"]');
            setButtonLoading(submitBtn, true);

            try {
                const response = await fetch(
                    "https://collab.boltnutritions.com/api/change_password",
                    {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                            email: user.email,
                            currentPassword,
                            newPassword
                        })
                    }
                );

                const data = await response.json();

                if (data.success) {
                    showPasswordMessage("Password updated successfully!", "success");
                    passwordForm.reset();
                } else {
                    showPasswordMessage(data.message || "Failed to update password", "error");
                }
            } catch (err) {
                console.error(err);
                showPasswordMessage("Connection error. Please try again.", "error");
            } finally {
                resetButton(submitBtn);
            }
        });
    }

    // Initialize logout button
    function initLogoutButton() {
        const logoutBtn = document.getElementById('LogoutBtn');
        if (logoutBtn) {
            logoutBtn.addEventListener('click', function(event) {
                event.preventDefault();
                
                const emptyChatState = {
                    messages: [],
                    unread: 0
                };
                localStorage.setItem('boltChat', JSON.stringify(emptyChatState));
                
                logout();
            });
        }
    }

    function togglePayoutFields() {
        const bankFields = document.getElementById("bankFields");
        const upiFields = document.getElementById("upiFields");
        
        if (!bankFields || !upiFields) return;

        if (document.getElementById("methodBank").checked) {
            bankFields.classList.remove("d-none");
            upiFields.classList.add("d-none");
        } else {
            bankFields.classList.add("d-none");
            upiFields.classList.remove("d-none");
        }
    }

    function showPasswordMessage(message, type) {
        const existingMsg = document.getElementById("passwordChangeMessage");
        if (existingMsg) existingMsg.remove();
        
        const messageDiv = document.createElement("div");
        messageDiv.id = "passwordChangeMessage";
        messageDiv.className = `alert alert-${type === 'success' ? 'success' : 'danger'} alert-dismissible fade show mt-3`;
        messageDiv.innerHTML = `
            ${message}
            <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
        `;
        
        const cardBody = passwordForm?.closest('.card-body');
        if (cardBody) {
            cardBody.append(messageDiv);
        }
    }
    // Initialize dashboard when page loads
    document.addEventListener("DOMContentLoaded", function() {
        const user = getUserData();
        if (user && user.email) {
            initDashboard();
        }
    });

    // dashboard campaign details
    document.addEventListener("DOMContentLoaded", async () => {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    const userEmail = user.email?.toLowerCase().trim();

    if (!userEmail) {
        console.warn("User not logged in");
        return;
    }
    const API_URL = `https://collab.boltnutritions.com/api/bind-influencer-campaign?email=${encodeURIComponent(userEmail)}`;
    try {
        const campaigns = await fetchUserCampaigns();
        loadInfluencerCampaign(campaigns);
        loadActiveCampaigns(campaigns);
    } catch (err) {
        console.error("Dashboard load failed", err);
        hideEmptySections();
    }
    async function fetchUserCampaigns() {
        const res = await fetch(API_URL);
        const result = await res.json();
        if (!result.success || !Array.isArray(result.data)) return [];
        return result.data.filter(c => c.email?.toLowerCase() === userEmail);
    }
    /* ================= MAIN CAMPAIGN ================= */
    function loadInfluencerCampaign(campaigns) {
        if (!campaigns.length) {
        hideEmptySections();
        return;
        }

        const data = campaigns[0];

        const skuNames = parseSku(data.json_data);

        setText(".onbording_product_name", data.campaign_name);
        setText(".onbording_product_date", formatDate(data.created_at));
        setText(".onborder_name", data.onboarder);
        setText(".onborder_email", data.email);

        setText(".approved_by", data.onboarder);
        setText(".approved_for", data.campaign_name);
        setText(".approval_date", formatDate(data.created_at));

        setText(".campaign_coordinator_name", data.coordinator);
        setText(".campaign_coordinator_email", data.email);
        updateSkuBadge(skuNames);
        // console.log("Influencer Campaign Loaded:", data);
    }
    /* ================= ACTIVE CAMPAIGNS ================= */
    function loadActiveCampaigns(campaigns) {
        const validCampaigns = campaigns.filter(c => {
        if (!c.json_data) return false;
        try {
            return JSON.parse(c.json_data).length > 0;
        } catch {
            return false;
        }
        });

        document.getElementById("activeCampaignCount").textContent = validCampaigns.length;

        const list = document.querySelector(".campaign-list");
        if (!list) return;

        if (!validCampaigns.length) {
        list.innerHTML = emptyState("No active campaigns assigned yet");
        return;
        }

        list.innerHTML = validCampaigns
        .map(c => {
            const { badgeClass, badgeText } = getStatusBadge(c.status);
            return `
            <div class="p-2 border rounded bg-light mb-2 d-flex justify-content-between align-items-center">
                <div>
                <small class="text-muted d-block">Campaign</small>
                <span class="fw-bold">${c.campaign_name || "Unnamed Campaign"}</span>
                </div>
                <span class="badge ${badgeClass} border px-2 py-1">${badgeText}</span>
            </div>`;
        })
        .join("");
    }
    /* ================= UI HELPERS ================= */
    function hideEmptySections() {
        [
        ".onbording_product_name",
        ".onbording_product_date",
        ".onborder_name",
        ".onborder_email",
        ".approved_by",
        ".approved_for",
        ".approval_date",
        ".campaign_coordinator_name",
        ".campaign_coordinator_email"
        ].forEach(sel => {
        const el = document.querySelector(sel);
        if (el) {
            el.textContent = "Not assigned";
            el.classList.add("text-muted", "fst-italic");
        }
        });

        updateSkuBadge(null);
    }
    function updateSkuBadge(skuNames) {
        const badge = document.querySelector(".bi-info-circle-fill")?.parentElement;
        if (!badge) return;

        badge.innerHTML = skuNames
        ? `
            <i class="bi bi-box-seam-fill text-info me-2"></i>
            <small class="fw-semibold">Product SKU: ${skuNames}</small>`
        : `
            <i class="bi bi-info-circle-fill text-muted me-2"></i>
            <small class="text-muted fst-italic">No product assigned yet</small>`;
    }
    function setText(selector, value) {
        const el = document.querySelector(selector);
        if (el) el.textContent = value || "N/A";
    }
    function parseSku(json) {
        try {
        return JSON.parse(json || "[]").map(s => s.sku).join(", ");
        } catch {
        return "";
        }
    }

    function formatDate(date) {
        return date ? new Date(date).toLocaleDateString() : "N/A";
    }

    function emptyState(text) {
        return `
        <div class="p-3 border rounded bg-light text-center">
            <small class="text-muted">${text}</small>
        </div>`;
    }

    function getStatusBadge(status) {
        return {
        approved: { badgeClass: "bg-soft-success text-success", badgeText: "Live" },
        pending: { badgeClass: "bg-soft-warning text-warning", badgeText: "Review" },
        rejected: { badgeClass: "bg-soft-danger text-danger", badgeText: "Rejected" }
        }[status] || { badgeClass: "bg-soft-success text-success", badgeText: "active" };
    }
    });

    // Revenue Analytics
    document.addEventListener('DOMContentLoaded', () => {
    const CONFIG = {
            tdsPercentage: 0,
            platformFeePercentage: 0,
            campaignBonusPercentage: 0
        };
        const $ = (id) => document.getElementById(id);
        const formatCurrency = (amount = 0) =>
            new Intl.NumberFormat('en-IN', {
                style: 'currency',
                currency: 'INR',
                maximumFractionDigits: 0
            }).format(isNaN(amount) ? 0 : amount);

        const toggleLoading = (loading) => {
            document.querySelectorAll('.total_balance').forEach(el => {
                el.textContent = loading ? 'Loading...' : el.dataset.value || el.textContent;
                el.classList.toggle('text-muted', loading);
            });
        };

        const toggleBlur = (blur) => {
            const el = $('revenue-metrics-container');
            if (!el) return;
            el.style.filter = blur ? 'blur(5px)' : 'none';
            el.style.opacity = blur ? '0.7' : '1';
        };

        const getUserEmail = () => {
            try {
                return (
                    JSON.parse(localStorage.getItem('user') || '{}')?.email ||
                    window.currentUser?.email ||
                    document.querySelector('[data-user-email]')?.dataset.userEmail
                )?.toLowerCase().trim() || null;
            } catch {
                return null;
            }
        };

        const showError = (msg) => {
            console.error(msg);
            document.querySelectorAll('.revenue-error-alert').forEach(e => e.remove());

            const alert = document.createElement('div');
            alert.className = 'alert alert-danger revenue-error-alert mt-2';
            alert.textContent = msg;

            $('revenue-metrics-container')?.after(alert);
            setTimeout(() => alert.remove(), 8000);
        };

        const fetchOrders = async (email) => {
            const res = await fetch(
                `https://collab.boltnutritions.com/api/influencer/orders/${encodeURIComponent(email)}`
            );
            if (!res.ok) throw new Error('Failed to fetch orders');
            const data = await res.json();
            return data.success ? data.orders || [] : [];
        };

    const checkApproval = async (email) => {
        try {
            const res = await fetch(
                'https://collab.boltnutritions.com/api/influencers'
            );

            if (!res.ok) throw new Error('Failed to fetch influencers');

            const result = await res.json();

            if (!result.success || !Array.isArray(result.data)) return false;

            const influencer = result.data.find(
                inf => inf.email?.toLowerCase() === email.toLowerCase()
            );
            // console.log(influencer, "ghggghg");
            return influencer?.Approved_by_POC?.toLowerCase() === 'approved';
        } catch (err) {
            console.error(err);
            return false;
        }
        };

        const calculateTotalValue = (orders) =>
            orders.reduce((sum, o) => {
                if (
                    o?.financial_status?.toLowerCase() === 'paid' &&
                    o?.fulfillment_status?.toLowerCase() !== 'cancelled'
                ) {
                    return sum + (parseFloat(o.total_price) || 0);
                }
                return sum;
            }, 0);

            const calculateMetrics = (total, approved) => {
                const campaignBonus = total * CONFIG.campaignBonusPercentage;

                if (!approved) {
                    return {
                        total,
                        cleared: 0,
                        pending: total,
                        campaignBonus,
                        tds: 0,
                        fee: 0,
                        payout: 0
                    };
                }

                const tds = total * CONFIG.tdsPercentage;
                const fee = total * CONFIG.platformFeePercentage;

                return {
                    total,
                    cleared: total,
                    pending: 0,
                    campaignBonus,
                    tds,
                    fee,
                    payout: Math.max(0, total + campaignBonus - tds - fee)
                };
            };
        const setValue = (id, value, prefix = '') => {
            const el = $(id);
            if (!el) return;
            el.textContent = prefix + formatCurrency(value);
            el.dataset.value = el.textContent;
        };

        const updateUI = (m, approved) => {
        setValue('total-revenue', m.total);
        setValue('cleared-balance', m.cleared);
        setValue('pending-review', m.pending);
        setValue('campaign-bonus', m.campaignBonus, m.campaignBonus ? '+ ' : '');
        setValue('tds-amount', m.tds, m.tds ? '- ' : '');
        setValue('platform-fee', m.fee, m.fee ? '- ' : '');
        setValue('upcoming-payout', m.payout);
        setValue('take-home-net', m.payout - 4);

        const status =
            document.getElementById('approval-status') ||
            document.querySelector('.d-flex.align-items-baseline')?.appendChild(
                Object.assign(document.createElement('span'), { id: 'approval-status' })
            );

        if (status) {
            status.textContent = approved ? '✓ Approved' : '⏳ Pending Review';
            status.className = `badge ms-2 ${approved ? 'bg-success' : 'bg-warning'}`;
        }

        document.getElementById('paymentAmount') &&
            (document.getElementById('paymentAmount').value = m.total.toFixed(0));
        };

        const addRefreshButton = () => {
            const container = document.querySelector('.d-flex.align-items-baseline');
            if (!container || $('refresh-btn')) return;

            const btn = document.createElement('button');
            btn.id = 'refresh-btn';
            btn.className = 'btn btn-sm btn-outline-success ms-2';
            btn.innerHTML = '⟳';

            btn.onclick = async () => {
                btn.disabled = true;
                toggleBlur(true);
                toggleLoading(true);
                await loadRevenue();
                btn.disabled = false;
            };

            container.appendChild(btn);
        };

        const loadRevenue = async () => {
            try {
                const email = getUserEmail();
                // if (!email) throw new Error('User email not found');
                if(email){
                    const [orders, approved] = await Promise.all([
                        fetchOrders(email),
                        checkApproval(email)
                    ]);
                    const total = calculateTotalValue(orders);
                    const metrics = calculateMetrics(total, approved);
                    console.log(total,"calculateMetrics")

                    updateUI(metrics, approved);
                }
            } catch (err) {
                showError(err.message);
            } finally {
                toggleBlur(false);
                toggleLoading(false);
            }
        };
        const init = () => {
            toggleBlur(true);
            toggleLoading(true);
            addRefreshButton();
            loadRevenue();
        };
        init();
    });

    // order inffluencerAPI
    document.addEventListener('DOMContentLoaded', () => {

        const formatCurrency = (amount = 0) =>
            new Intl.NumberFormat('en-IN', {
                style: 'currency',
                currency: 'INR',
                minimumFractionDigits: 2
            }).format(isNaN(amount) ? 0 : amount);

        const getLoggedInUserEmail = () => {
            try {
                return getUserData()?.email?.toLowerCase().trim() || null;
            } catch {
                return null;
            }
        };

        const loadUserOrders = async () => {
            const email = getLoggedInUserEmail();
            if (!email) return showError('User email not found. Please login again.');

            try {
                const res = await fetch('https://collab.boltnutritions.com/api/influencers');
                if (!res.ok) throw new Error(res.status);

                const { success, shopify_orders = [] } = await res.json();
                if (!success) throw new Error('API failed');

                const userOrders = shopify_orders.filter(
                    o => o.customer?.email?.toLowerCase().trim() === email
                );

                showOrders(userOrders);
            } catch (err) {
                console.error(err);
                showError('Failed to load orders. Please try again later.');
            }
        };

        const getStatusBadge = (status = 'Unknown') => {
            const text = status.charAt(0).toUpperCase() + status.slice(1);
            let cls = 'bg-secondary';

            if (/fulfilled|shipped/i.test(status))
                cls = 'bg-success-subtle text-success border border-success-subtle';
            else if (/paid|processing/i.test(status))
                cls = 'bg-warning-subtle text-warning border border-warning-subtle';
            else if (/cancelled/i.test(status))
                cls = 'bg-danger-subtle text-danger border border-danger-subtle';
            else if (/unfulfilled/i.test(status))
                cls = 'bg-info-subtle text-info border border-info-subtle';

            return `<span class="badge ${cls} px-3">${text}</span>`;
        };

        const showOrders = (orders = []) => {
            const tbody = document.getElementById('OrdersTableBody');
            if (!tbody) return;

            if (!orders.length) {
                tbody.innerHTML = `
                    <tr>
                        <td colspan="6" class="text-center text-muted py-4">
                            No orders found
                        </td>
                    </tr>`;
                return;
            }

            tbody.innerHTML = orders.map(order => {
                const date = order.customer?.created_at
                    ? new Date(order.customer.created_at).toLocaleDateString('en-IN', {
                        day: 'numeric', month: 'short', year: 'numeric'
                    })
                    : 'N/A';

                const status = order.fulfillment_status || order.financial_status;
                const orderName = (order.name || '').replace(/^#/, '').replace(/'/g, "\\'");

                return `
                    <tr class="text-nowrap">
                        <td class="ps-4 fw-bold text-primary">${order.name || 'N/A'}</td>
                        <td class="text-muted small">${date}</td>
                        <td>
                            <div class="d-flex align-items-center">
                                <div class="bg-light rounded p-1 me-2 d-flex align-items-center justify-content-center"
                                    style="width:32px;height:32px;">📦</div>
                                <span>${order.title || 'N/A'}</span>
                            </div>
                        </td>
                        <td class="fw-bold">${formatCurrency(order.total_price)}</td>
                        <td>${getStatusBadge(status)}</td>
                        <td class="text-center pe-4">
                            <button class="btn btn-lg btn-light border"
                                onclick="trackOrder('${orderName}')">
                                Track
                            </button>
                        </td>
                    </tr>
                `;
            }).join('');
        };

        const showError = (msg) => {
            const tbody = document.getElementById('OrdersTableBody');
            if (!tbody) return;
            tbody.innerHTML = `
                <tr>
                    <td colspan="6" class="text-center text-danger py-4">${msg}</td>
                </tr>`;
        };

        window.trackOrder = (orderName) => {
            window.open(
                `https://boltorder.ithinklogistics.co.in/postship/tracking/${orderName}`,
                '_blank'
            );
        };
        loadUserOrders();
    });

   
// PAYMENT  AND HISTORY
document.addEventListener('DOMContentLoaded', function () {
    const getUserData = () => {
        try {
            const profileStr = localStorage.getItem("userProfile");
            const userData = (profileStr && profileStr !== "undefined")
                ? JSON.parse(profileStr)
                : {};
            return {
                email: userData.email || null,
                infNo: userData.inf_no || userData.id || null
            };
        } catch {
            return { email: null, infNo: null };
        }
    };

    const getUserInfNo = () => {
        try {
            let profile = {};
            
            const userProfile = localStorage.getItem("userProfile");
            if (userProfile) {
                profile = JSON.parse(userProfile);
            }
            
            if (!profile.inf_no && !profile.id) {
                const user = localStorage.getItem("user");
                if (user) {
                    const userData = JSON.parse(user);
                    profile = userData;
                }
            }
            
            return profile.inf_no || profile.id || profile.user_id || profile.influencer_id || null;
        } catch (e) {
            console.error("Error parsing user data:", e);
            return null;
        }
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return "-";
        const date = new Date(dateStr);
        return isNaN(date) ? "-" : date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric"
        });
    };

    const formatAmount = (amt) => {
        const amount = parseFloat(amt) || 0;
        return amount === 0
            ? `<span class="text-muted">₹0.00</span>`
            : `₹${amount.toLocaleString("en-IN", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}`;
    };

    const getStatusBadge = (status = "queued") => {
        if (!status) status = "queued";
        
        const map = {
            queued: {
                cls: "bg-warning text-dark bg-opacity-10",
                icon: "bi-clock",
                text: "Queued"
            },
            processing: {
                cls: "bg-info text-dark bg-opacity-10",
                icon: "bi-arrow-repeat",
                text: "Processing"
            },
            paid: {
                cls: "bg-success text-white", 
                icon: "bi-check-circle-fill",
                text: "Paid"
            },
            failed: {
                cls: "bg-danger text-white",
                icon: "bi-x-circle-fill",
                text: "Failed"
            }
        };

        const s = map[status.toLowerCase()] || map.queued;

        return `
            <span class="badge ${s.cls} small px-2 py-1 rounded-pill">
                <i class="bi ${s.icon} me-1"></i>${s.text}
            </span>
        `;
    };

    async function loadPaymentHistory() {
        const infNo = getUserInfNo();
        
        if (!infNo) {
            console.log("No influencer number found");
            return;
        }

        const tableBody = document.querySelector(".payment-history-section tbody");
        if (!tableBody) {
            console.log("Table body not found");
            return;
        }

        tableBody.innerHTML = `
            <tr>
                <td colspan="5" class="text-center py-4">
                    <div class="spinner-border spinner-border-sm text-primary"></div>
                    <div class="small text-muted mt-2">Loading payment history...</div>
                </td>
            </tr>`;

        try {
            const res = await fetch("https://collab.boltnutritions.com/api/payment-request", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                }
            });

            if (!res.ok) {
                throw new Error(`HTTP error! Status: ${res.status}`);
            }

            const json = await res.json();
            const dataArray = Array.isArray(json.data)
                ? json.data
                : Array.isArray(json)
                ? json
                : [];

            if (!dataArray.length) {
                tableBody.innerHTML = `
                    <tr>
                        <td colspan="5" class="text-center text-muted py-4">
                            <i class="bi bi-receipt me-2"></i>No payment history found
                        </td>
                    </tr>`;
                return;
            }

            const payments = dataArray.filter(p =>
                String(p.inf_no || "").toUpperCase() === String(infNo).toUpperCase()
            );

            if (!payments.length) {
                tableBody.innerHTML = `
                    <tr>
                        <td colspan="5" class="text-center text-muted py-4">
                            <i class="bi bi-receipt me-2"></i>No payment history found
                        </td>
                    </tr>`;
                return;
            }

           tableBody.innerHTML = payments
                .sort((a, b) => new Date(b.last_updated) - new Date(a.last_updated))
                .slice(0, 5)
                .map(p => {

                    const total =
                        parseFloat(p.reel_amt || 0) +
                        parseFloat(p.story_amt || 0) +
                        parseFloat(p.static_amt || 0);

                    const fees = 4.00;
                    const net = total - fees;

                    return `
                    <tr class="border-bottom align-middle">
                        
                        <td>
                            <div class="fw-semibold">${formatDate(p.last_updated)}</div>
                        </td>

                        <td class="fw-semibold ${parseFloat(p.reel_amt) === 0 ? 'text-muted' : 'text-dark'}">
                            ${formatAmount(p.reel_amt)}
                        </td>

                        <td class="fw-semibold ${parseFloat(p.story_amt) === 0 ? 'text-muted' : 'text-dark'}">
                            ${formatAmount(p.story_amt)}
                        </td>

                        <td class="fw-semibold ${parseFloat(p.static_amt) === 0 ? 'text-muted' : 'text-dark'}">
                            ${formatAmount(p.static_amt)}
                        </td>

                        <td>
                            <div class="d-flex flex-column gap-2">

                                <div>
                                    ${getStatusBadge(p.payment_status || "queued")}
                                </div>

                                <div class="p-2 rounded-3 border bg-light-subtle">

                                    <div class="d-flex justify-content-between small text-danger">
                                        <span>Fees</span>
                                        <span class="fw-semibold">-₹${fees}</span>
                                    </div>

                                    <div class="d-flex justify-content-between small mt-1 text-muted">
                                        <span>Gross</span>
                                        <span>₹${total.toFixed(2)}</span>
                                    </div>

                                    <hr class="my-1">

                                    <div class="d-flex justify-content-between fw-bold text-dark">
                                        <span>Net</span>
                                        <span class="text-success">
                                            ₹${net.toLocaleString("en-IN", {
                                                minimumFractionDigits: 2
                                            })}
                                        </span>
                                    </div>

                                </div>
                            </div>
                        </td>
                    </tr>
                    `;
                }).join("");
        } catch (err) {
            console.error("Payment history error:", err);

            tableBody.innerHTML = `
                <tr>
                    <td colspan="5" class="text-center text-danger py-4">
                        <i class="bi bi-exclamation-triangle me-2"></i>
                        Unable to load payment history
                    </td>
                </tr>`;
        }
    }

    const style = document.createElement("style");
    style.textContent = `
        .very-small { font-size: 0.75rem; line-height: 1.3; }
        .border-bottom { border-bottom: 1px solid #f0f0f0 !important; }
        .payment-history-section .btn-outline-primary { cursor: pointer; }
    `;
    document.head.appendChild(style);

    const paymentForm = document.getElementById('paymentForm');
    if (!paymentForm) return;

    const paymentAmountInput = document.getElementById('paymentAmount');
    const contentTypeRadios = document.querySelectorAll('input[name="contentType"]');
    const eligibilityPercentSpan = document.getElementById('eligibilityPercent');
    const netAmountSpan = document.getElementById('netAmount');
    const submitPaymentBtn = document.getElementById('submitPaymentBtn');
    const paymentDescription = document.getElementById('paymentDescription');
    const verifyCheck = document.getElementById('verifyCheck');

    const { infNo, email } = getUserData();
    if (!infNo) return;

    let lockedTypes = {
        reel: false,
        story: false,
        static: false
    };

    let cachedApprovalStatus = null;
    let lastApprovalCheck = 0;
    const APPROVAL_CACHE_DURATION = 60000;

    async function checkUserApprovalStatus(forceRefresh = false) {
        const now = Date.now();
        if (!forceRefresh && cachedApprovalStatus !== null && (now - lastApprovalCheck) < APPROVAL_CACHE_DURATION) {
            return cachedApprovalStatus;
        }

        try {
            const res = await fetch('https://collab.boltnutritions.com/api/influencers');
            const data = await res.json();
            const found =
                data?.poc_check?.find(i => String(i.inf_no) === String(infNo)) ||
                data?.data?.find(i => i.email === email);

            cachedApprovalStatus = found?.Approved_by_POC?.toLowerCase() === 'approved';
            lastApprovalCheck = now;
            return cachedApprovalStatus;
        } catch {
            cachedApprovalStatus = false;
            lastApprovalCheck = now;
            return false;
        }
    }

    async function applyLocksFromAPI() {
        try {
            const res = await fetch('https://collab.boltnutritions.com/api/payment-request');
            const result = await res.json();

            const record = result?.data?.find(
                item => String(item.inf_no) === String(infNo)
            );

            if (!record) return;

            lockedTypes = {
                reel: parseFloat(record.reel_amt) > 0,
                story: parseFloat(record.story_amt) > 0,
                static: parseFloat(record.static_amt) > 0
            };

            contentTypeRadios.forEach(radio => {
                if (lockedTypes[radio.id]) {
                    radio.disabled = true;
                    radio.checked = false;
                    radio.parentElement.style.opacity = "0.5";
                    radio.parentElement.title = "Already applied";
                } else {
                    radio.disabled = false;
                    radio.parentElement.style.opacity = "1";
                    radio.parentElement.title = "";
                }
            });

        } catch {
            alert("Unable to verify previous applications");
        }
    }

    async function calculateAndUpdatePayout() {
        const amount = parseFloat(paymentAmountInput?.value) || 0;
        const selectedRadio = document.querySelector('input[name="contentType"]:checked');

        const isVerified = verifyCheck?.textContent.toLowerCase().includes('verified');
        const isApproved = await checkUserApprovalStatus();

        let percentage = selectedRadio ? parseInt(selectedRadio.value) || 0 : 0;
        let netAmount = amount * (percentage / 100);

        if (eligibilityPercentSpan) {
            eligibilityPercentSpan.textContent = `${percentage}%`;
        }

        if (netAmountSpan) {
            netAmountSpan.textContent = `₹${netAmount.toFixed(0)}`;
        }

        const canSubmit =
            isVerified &&
            isApproved &&
            selectedRadio &&
            !lockedTypes[selectedRadio.id] &&
            amount > 0;

        submitPaymentBtn.disabled = !canSubmit;
        submitPaymentBtn.style.opacity = canSubmit ? 1 : 0.5;
    }

    paymentAmountInput?.addEventListener('input', function(e) {
        this.value = this.value.replace(/[^0-9.]/g, '');
        
        const parts = this.value.split('.');
        if (parts.length > 2) {
            this.value = parts[0] + '.' + parts.slice(1).join('');
        }
        
        calculateAndUpdatePayout();
    });

    paymentForm.addEventListener('submit', async (e) => {
        e.preventDefault();

        const selectedRadio = document.querySelector('input[name="contentType"]:checked');
        if (!selectedRadio) {
            alert("Please select a content type.");
            return;
        }

        if (lockedTypes[selectedRadio.id]) {
            alert("You have already applied for this content type.");
            return;
        }

        const amount = parseFloat(paymentAmountInput.value);
        if (!amount || amount <= 0) {
            alert("Please enter a valid campaign amount.");
            return;
        }

        submitPaymentBtn.disabled = true;
        submitPaymentBtn.textContent = "Submitting...";

        try {
            const res = await fetch(
                'https://collab.boltnutritions.com/api/payment-request',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-admin-key': 'supersecretadminkey'
                    },
                    body: JSON.stringify({
                        inf_no: infNo,
                        content_type: selectedRadio.id,
                        total_amount: amount,
                        description: paymentDescription.value
                    })
                }
            );

            const result = await res.json();

            if (result.success) {
                alert("Request submitted successfully.");
                
                paymentDescription.value = '';
                
                contentTypeRadios.forEach(radio => {
                    radio.checked = false;
                });
                
                if (eligibilityPercentSpan) {
                    eligibilityPercentSpan.textContent = '0%';
                }
                if (netAmountSpan) {
                    netAmountSpan.textContent = '₹0';
                }
                
                loadPaymentHistory().catch(console.error);
                
                await applyLocksFromAPI();
                
                cachedApprovalStatus = null;
                await checkUserApprovalStatus(true);
                
                await calculateAndUpdatePayout();
                
            } else {
                alert(result.message || "Submission failed.");
            }
        } catch (error) {
            console.error("Submission error:", error);
            alert("Error submitting request. Please try again.");
        } finally {
            submitPaymentBtn.disabled = false;
            submitPaymentBtn.textContent = "Submit Payment Request";
        }
    });

    contentTypeRadios.forEach(r => r.addEventListener('change', calculateAndUpdatePayout));

    Promise.all([
        applyLocksFromAPI(),
        checkUserApprovalStatus(),
        loadPaymentHistory()
    ]).then(() => {
        calculateAndUpdatePayout();
    }).catch(console.error);

    const isDashboardActive = document.querySelector(".home__panel.dashboard-section");
    try {
        const userStrDashboard = localStorage.getItem("user");
        if (userStrDashboard) {
            const roleCheck = JSON.parse(userStrDashboard);
            if (roleCheck && roleCheck.role === "influencer") {
                isDashboardActive?.classList.remove("hide");
                isDashboardActive?.classList.add("active");
            } else {
                isDashboardActive?.classList.add("hide");
                isDashboardActive?.classList.remove("active");
            }
        }
    } catch (e) {
        console.error("Error checking user role:", e);
    }
});

//  dashboard profile image
(function initProfileImage() {
    const load = async () => {
        try {
            const userProfile = JSON.parse(localStorage.getItem("userProfile") || "{}");
            if (!userProfile.instagram_profile) return;
            
            const username = userProfile.instagram_profile
                .replace(/https?:\/\/(www\.)?instagram\.com\//, '')
                .split('/')[0]
                .split('?')[0]
                .trim();
            
            if (!username) return;
            
            const img = document.getElementById("instaProfileImg");
            const mobile = document.getElementById("mobileAvatar");
            if (!img) return;
            
            const cachedData = sessionStorage.getItem(`instagram_profile_${username}`);
            const cacheTimestamp = sessionStorage.getItem(`instagram_profile_${username}_timestamp`);
            
            if (cachedData && cacheTimestamp) {
                const now = Date.now();
                const fiveMinutes = 5 * 60 * 1000;
                
                if (now - parseInt(cacheTimestamp) < fiveMinutes) {
                    const data = JSON.parse(cachedData);
                    updateProfileUI(data, img, mobile);
                    return;
                }
            }
            
            img.style.opacity = '0.5';
            
            const res = await fetch(`https://collab.boltnutritions.com/api/instagram/userProfile?username=${encodeURIComponent(username)}`);
            const data = await res.json();
            
            if (data?.success && data.data?.profilePic) {
                sessionStorage.setItem(`instagram_profile_${username}`, JSON.stringify(data.data));
                sessionStorage.setItem(`instagram_profile_${username}_timestamp`, Date.now().toString());
                
                updateProfileUI(data.data, img, mobile);
            }
        } catch(e) {
            console.debug('Profile image load failed:', e);
            const img = document.getElementById("instaProfileImg");
            if (img) img.style.opacity = '1';
        }
    };
    
    // Helper function to update UI
    const updateProfileUI = (profileData, img, mobile) => {
        img.src = profileData.profilePic;
        img.style.opacity = '1';
        
        if (mobile) {
            mobile.innerHTML = `<img src="${profileData.profilePic}" style="width:100%;height:100%;object-fit:cover;border-radius:50%;">`;
            mobile.classList.remove("bg-primary", "text-white");
        }
        if (document.getElementById("followersCount")) {
            document.getElementById("followersCount").textContent = (profileData.followers || 0).toLocaleString();
        }
        if (document.getElementById("followingCount")) {
            document.getElementById("followingCount").textContent = (profileData.following || 0).toLocaleString();
        }
    };
    
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', load);
    } else {
        load();
    }
    
    const originalSetItem = localStorage.setItem;
    localStorage.setItem = function(key, value) {
        originalSetItem.call(this, key, value);
        if (key === 'userProfile' || key === 'user') {
            const username = JSON.parse(value || "{}").instagram_profile;
            if (username) {
                const cleanUsername = username
                    .replace(/https?:\/\/(www\.)?instagram\.com\//, '')
                    .split('/')[0]
                    .split('?')[0]
                    .trim();
                sessionStorage.removeItem(`instagram_profile_${cleanUsername}`);
                sessionStorage.removeItem(`instagram_profile_${cleanUsername}_timestamp`);
            }
            load();
        }
    };
    
    window.addEventListener('storage', function(e) {
        if (e.key === 'userProfile' || e.key === 'user') {
            const username = JSON.parse(e.newValue || "{}").instagram_profile;
            if (username) {
                const cleanUsername = username
                    .replace(/https?:\/\/(www\.)?instagram\.com\//, '')
                    .split('/')[0]
                    .split('?')[0]
                    .trim();
                sessionStorage.removeItem(`instagram_profile_${cleanUsername}`);
                sessionStorage.removeItem(`instagram_profile_${cleanUsername}_timestamp`);
            }
            load();
        }
    });
    
    window.refreshProfileImage = load;
})();

// chatbox
(function() {
    'use strict';

    let state = {
        isOpen: false,
        unread: 0,
        messages: []
    };

    const dom = {
        toggle: null,
        container: null,
        messages: null,
        input: null,
        sendBtn: null,
        badge: null,
        typing: null,
        chatWidget: null
    };

    const STORAGE_KEY = 'boltChat';
    const SUPPORT_NAME = 'Bolt Support';

    function init() {
        if (dom.toggle) return;

        dom.toggle = document.getElementById('chatToggleBtn');
        dom.container = document.getElementById('chatContainer');
        dom.messages = document.getElementById('chatMessages');
        dom.input = document.getElementById('chatInput');
        dom.sendBtn = document.getElementById('sendBtn');
        dom.badge = document.getElementById('chatNotificationBadge');
        dom.typing = document.getElementById('typingIndicator');
        dom.chatWidget = document.querySelector('.chat-widget');

        if (!dom.toggle || !dom.container) return;

        const user = JSON.parse(localStorage.getItem("user") || "{}");
        
        if (user.email) {
            if (dom.chatWidget) dom.chatWidget.classList.remove("d-none");
            loadState();
            setupListeners();
            render();
            
            if (state.messages.length === 0) {
                addWelcome();
            }
        } else {
            if (dom.chatWidget) dom.chatWidget.classList.add("d-none");
            return;
        }
    }

    // ----- EVENT LISTENERS -----
    function setupListeners() {
        dom.toggle.addEventListener('click', toggleChat);

        document.querySelectorAll('.close-chat, .minimize-chat').forEach(btn => {
            btn.addEventListener('click', closeChat);
        });
        dom.sendBtn.addEventListener('click', sendMessage);
        
        dom.input.addEventListener('input', handleInput);
        dom.input.addEventListener('keydown', handleKeydown);

        window.addEventListener('storage', (e) => {
            if (e.key === STORAGE_KEY) {
                loadState();
                render();
            }
        });

        // Listen for login/logout events
        window.addEventListener('storage', (e) => {
            if (e.key === 'user') {
                const user = JSON.parse(localStorage.getItem("user") || "{}");
                if (user.email) {
                    if (dom.chatWidget) dom.chatWidget.classList.remove("d-none");
                    if (state.messages.length === 0) {
                        addWelcome();
                    }
                } else {
                    if (dom.chatWidget) dom.chatWidget.classList.add("d-none");
                    // Optionally clear chat history on logout
                    localStorage.removeItem(STORAGE_KEY);
                }
            }
        });
    }

    function toggleChat() {
        state.isOpen = !state.isOpen;
        dom.container.classList.toggle('active', state.isOpen);
        
        if (state.isOpen) {
            resetUnread();
            dom.input.focus();
            scrollToBottom();
        }
    }

    function closeChat() {
        state.isOpen = false;
        dom.container.classList.remove('active');
    }

    function sendMessage() {
        const text = dom.input.value.trim();
        if (!text) return;

        // Add user message
        addMessage({
            type: 'user',
            message: text,
            timestamp: new Date().toISOString()
        });

        // Clear input
        dom.input.value = '';
        dom.input.style.height = 'auto';
        dom.sendBtn.disabled = true;

        // Show typing
        if (dom.typing) dom.typing.classList.add('active');
        scrollToBottom();

        setTimeout(() => {
            if (dom.typing) dom.typing.classList.remove('active');
            
            addMessage({
                type: 'support',
                message: getResponse(text),
                timestamp: new Date().toISOString()
            });
        }, 800 + Math.random() * 700);
    }

    function addMessage(msg) {
        msg.id = Date.now() + Math.random();
        msg.read = state.isOpen || msg.type === 'user';
        
        state.messages.push(msg);
        saveState();
        render();

        if (!state.isOpen && msg.type === 'support') {
            incrementUnread();
        }
        
        scrollToBottom();
    }

    function addWelcome() {
        addMessage({
            type: 'support',
            message: "Hi there! 👋\nI'm your Bolt Nutrition support assistant. How can I help you today?",
            timestamp: new Date().toISOString(),
            read: true
        });
    }

    function render() {
        if (!dom.messages) return;

        dom.messages.innerHTML = '';        
        state.messages.forEach(msg => {
            dom.messages.appendChild(createMessageElement(msg));
        });

        if (dom.typing) dom.messages.appendChild(dom.typing);

        if (state.isOpen) {
            markAllRead();
        }
    }

    function createMessageElement(msg) {
        const wrapper = document.createElement('div');
        wrapper.className = `message-wrapper ${msg.type}`;
        
        const avatar = document.createElement('div');
        avatar.className = 'message-avatar';
        avatar.innerHTML = msg.type === 'support' 
            ? '<i class="bi bi-headset"></i>' 
            : '<i class="bi bi-person"></i>';
        
        const content = document.createElement('div');
        content.className = 'message-content';
        
        const bubble = document.createElement('div');
        bubble.className = 'message-bubble';
        bubble.innerHTML = msg.message.replace(/\n/g, '<br>');
        
        const time = document.createElement('small');
        time.className = 'message-time';
        time.textContent = formatTime(msg.timestamp);
        
        content.appendChild(bubble);
        content.appendChild(time);
        wrapper.appendChild(avatar);
        wrapper.appendChild(content);
        
        return wrapper;
    }

    function formatTime(iso) {
        const date = new Date(iso);
        const now = new Date();
        const diff = Math.floor((now - date) / 60000);
        
        if (diff < 1) return 'Just now';
        if (diff < 60) return `${diff}m ago`;
        return date.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' });
    }

    function handleInput() {
        const val = dom.input.value.trim();
        dom.sendBtn.disabled = !val;
        
        dom.input.style.height = 'auto';
        dom.input.style.height = Math.min(dom.input.scrollHeight, 100) + 'px';
    }

    function handleKeydown(e) {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            sendMessage();
        }
    }

    function scrollToBottom() {
        if (dom.messages) {
            dom.messages.scrollTop = dom.messages.scrollHeight;
        }
    }

    function incrementUnread() {
        state.unread++;
        updateBadge();
    }

    function resetUnread() {
        state.unread = 0;
        updateBadge();
        markAllRead();
    }

    function updateBadge() {
        if (dom.badge) {
            dom.badge.textContent = state.unread;
            dom.badge.style.display = state.unread > 0 ? 'flex' : 'none';
        }
    }

    function markAllRead() {
        state.messages.forEach(msg => msg.read = true);
        saveState();
    }

    function loadState() {
        try {
            const saved = localStorage.getItem(STORAGE_KEY);
            if (saved) {
                const parsed = JSON.parse(saved);
                state.messages = parsed.messages || [];
                state.unread = parsed.unread || 0;
                
                state.messages = state.messages.filter(m => m && m.type && m.message);
            }
        } catch (e) {
            console.debug('Storage read failed, starting fresh');
            state.messages = [];
            state.unread = 0;
        }
        updateBadge();
    }

    function saveState() {
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify({
                messages: state.messages,
                unread: state.unread
            }));
        } catch (e) {
            console.debug('Storage write failed');
        }
    }

    function getResponse(input) {
        const text = input.toLowerCase().trim();
        
        // Get user data from localStorage
        let userProfile = null;
        let infCode = null;
        try {
            userProfile = JSON.parse(localStorage.getItem('userProfile') || 'null');
            infCode = JSON.parse(localStorage.getItem('infCode') || 'null');
        } catch (e) {}
        
        // Greetings & Welcome
        if (/\b(hi|hello|hey|morning|evening|afternoon|hola|sup|howdy)\b/.test(text)) {
            if (userProfile?.first_name) {
                return `👋 Hello ${userProfile.first_name}! Welcome to Bolt Nutrition Influencer Support. How can I help you today?`;
            }
            return "👋 Hello! Welcome to Bolt Nutrition Influencer Support. How can I assist you today?";
        }
        
        // INF Code Queries
        if (/\b(inf|code|referral|influencer.*code|what.*code|show.*code|where.*code|find.*code|my.*code|get.*code|share.*code)\b/i.test(text)) {

            const code = document.getElementById("infCodes")?.innerText?.trim();

            return (code && code !== "Under Review")
                ? `🔑 Your INF code is: **${code}**\n\nUse this code to purchase your items from our influencer page. <a href="https://boltnutritions.com/pages/influencer-page" target="_blank" style="color:#ff6600; font-weight:600; text-decoration:underline;"> Shop Now</a>\nYou can also find it at the top of your dashboard.`
                : "⏳ Your unique INF code will appear after profile approval. Please check the top of your dashboard once approved.";
        }
    
        // Dashboard Overview
        if (/\b(dashboard|home|overview|main|landing)\b/i.test(text)) {
            const code = document.getElementById("infCodes")?.innerText?.trim();
                return `📊 Your Dashboard Overview:
            ${code && code !== "Under Review" ? `• INF Code: ${code}\n` : ""}• Campaign Status & Approvals
            • Revenue Analytics & Earnings
            • Leaderboard Ranking
            • Profile Management
            • Payment Requests

            Access all features from the dashboard menu. Need help with something specific?`;
        }
        
        // Profile Management
        if (/\b(profile|edit|update.*info|personal|my.*info|account.*info|settings)\b/.test(text)) {
            if (userProfile) {
                let response = "👤 **Your Profile Information:**\n\n";
                if (userProfile.first_name) response += `Name: ${userProfile.first_name} ${userProfile.last_name || ''}\n`;
                if (userProfile.email) response += `Email: ${userProfile.email}\n`;
                if (userProfile.mobile) response += `Phone: ${userProfile.mobile}\n`;
                if (userProfile.instagram_profile) response += `Instagram: ${userProfile.instagram_profile}\n`;
                if (userProfile.followers) response += `Followers: ${Number(userProfile.followers).toLocaleString()}\n`;
                if (userProfile.onboard_type) response += `Niche: ${userProfile.onboard_type}\n`;
                if (userProfile.city || userProfile.state) response += `Location: ${userProfile.city || ''} ${userProfile.state || ''}\n`.trim();
                
                response += `\n📝 To update: Go to 'My Profile' in dashboard.\n`;
                response += `• Editable: Phone, Instagram handle, Address\n• Fixed: Name, Email (contact support for changes)`;
                return response;
            }
            return "👤 **Profile Management:**\n\nUpdate your profile in 'My Profile' section. You can edit:\n• Phone number\n• Instagram handle\n• Address\n\nName and email cannot be changed directly - please contact support for updates.";
        }
        
        // Campaigns
        if (/\b(campaign|active|status|opportunity|brand|campaigns)\b/.test(text)) {
            return "📢 Campaign Information:\n\n• View active campaigns in 'Dashboard Campaigns' section\n• Approval takes 24-48 hours\n• Coordinator details shown per campaign\n\nNeed specific campaign details? Check your dashboard!";
        }
        
        // Payments & Earnings
        if (/\b(payment|payout|money|refund|balance|earnings|revenue|balance|paid|income|commission)\b/.test(text)) {
            return "💰 **Payment & Earnings:**\n\n**Rates:**\n• Reels: 70% of campaign value\n• Stories: 20% of campaign value\n• Static Posts: 10% of campaign value\n\n**Process:**\n1. Submit content in 'Payment Request'\n2. Wait 1-2 days for verification\n3. Request payout once verified\n4. Payments are processed within 3 to 4 business days.\n\nAdd bank/UPI details before requesting payment.";
        }
        
        // Bank & UPI Details
        if (/\b(bank|account|upi|ifsc|payout method|payment method|bank details|bank account)\b/.test(text)) {
            return "🏦 **Bank Account Setup:**\n\nNavigate to: **Payment Request** → **Bank Account Details**\n\nRequired Information:\n• Account Holder Name\n• Bank Account Number\n• IFSC Code\n• UPI ID (optional)\n\n✅ Double-check all details to avoid payment delays!\n⚠️ Updates take 24 hours to reflect.";
        }
        
        // Content Submission
        if (/\b(content|submit|upload|reel|story|post|verification|content.*submit|upload.*content)\b/.test(text)) {
            return "🎬 **Content Submission:**\n\n**Steps:**\n1. Go to 'Payment Request'\n2. Click 'Submit Content'\n3. Select content type (Reel/Story/Static)\n4. Add URL, title, and posting date\n5. Submit for verification\n\n⏱️ Verification takes 1-2 working days\n✅ Once verified, you can request payment\n\n**Pro tip:** Submit content immediately after posting!";
        }
        // How to Order
        if (/\b(how to order|buy|purchase|cart|shop now|place order)\b/.test(text)) {
            return "🛒 <strong>How to Order:</strong><br><br>" +
                "• Click on the <strong>Cart</strong> button in the left bottom corner<br>" +
                "• Or click on the <strong>'Shop Now'</strong> button on the dashboard<br>" +
                "• You can also purchase directly from here: " +
                "<a href='https://boltnutritions.com/pages/influencer-page' target='_blank'>Shop Now</a><br><br>" +
                "Once added to cart, proceed to checkout and complete your payment securely.<br><br>" +
                "Need help? Contact social.in@boltnutritions.com.";
        }

        // Orders & Shipping
        if (/\b(order|product|ship|delivery|track|shipping|perks|merch)\b/.test(text)) {
            return "📦 <strong>Orders & Shipping:</strong><br><br>" +
                "• View history in 'Perks & Orders'<br>" +
                "• Shipping: 5-7 business days<br>" +
                "• Track orders from 'Action' menu<br>" +
                "• You can also track your order here: " +
                "<a href='https://boltorder.ithinklogistics.co.in/' target='_blank'>Track Your Order</a><br>" +
                "• Free shipping on all influencer perks<br><br>" +
                "For order issues, contact social.in@boltnutritions.com with your order ID.";
        }

        // Password & Security
        if (/\b(password|change.*pass|security|login|reset|forgot)\b/.test(text)) {
            return "🔐 **Password & Security:**\n\n**Change Password:**\n1. Go to 'Change Password' in dashboard\n2. Enter current password\n3. New password requirements:\n   • Minimum 8 characters\n   • At least 1 uppercase letter\n   • At least 1 lowercase letter\n   • At least 1 number\n   • At least 1 special character";
        }
        
        // Contact & Support
        if (/\b(contact|support|help|issue|problem|complaint|query|assist)\b/.test(text)) {
            let response = "📞 **Contact Support:**\n\n";
            response += "**Call:** +91 7990387779 (Mon-Fri, 9am-6pm)\n";
            response += "**Email:** social.in@boltnutritions.com\n";
            response += "**Dashboard:** Use 'Contact Us' form\n\n";
            
            if (userProfile?.first_name) {
                response += `Also, ${userProfile.first_name}, you can reach your campaign coordinator directly from your dashboard - look for the 'Email' button next to their name.`;
            } else {
                response += "You can also reach your campaign coordinator directly from your dashboard - look for the 'Email' button next to their name.";
            }
            return response;
        }
        
        // Coordinator
        if (/\b(coordinator|manager|contact person|point of contact|poc|campaign manager)\b/.test(text)) {
            return "👥 **Campaign Coordinator:**\n\n• Find coordinator details on your dashboard\n• Click 'Email' button to contact them directly\n• Response time: 24-48 hours\n• For urgent issues, use main support channels\n\nYour coordinator handles campaign briefs, content approval, and campaign-specific questions.";
        }
        
        // Leaderboard & Performance
        if (/\b(leaderboard|ranking|performance|stats|analytics|reach|engagement|position|rank)\b/.test(text)) {
            if (userProfile?.followers) {
                return `🏆 **Your Performance:**\n\n• Followers: ${Number(userProfile.followers).toLocaleString()}\n• Check your rank on the influencer leaderboard\n• Ranking based on: Reach, Engagement, Content quality\n• Top performers get:\n  - Premium campaigns\n  - Higher payout rates\n  - Exclusive brand collaborations\n\nKeep creating quality content to climb the ranks! 🚀`;
            }
            return "🏆 **Leaderboard:**\n\nCheck the influencer leaderboard on your dashboard.\n\n**Ranking factors:**\n• Reach & impressions\n• Engagement rate\n• Content quality\n• Consistency\n\nHigher ranks = Premium campaigns & better rates!";
        }
        
        // Account Creation Date
        if (/\b(joined|when|start|created|member since|signup|registration)\b.*\b(account|profile|platform)\b/.test(text)) {
            if (userProfile?.created_at) {
                const date = new Date(userProfile.created_at).toLocaleDateString('en-IN', {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric'
                });
                return `🎉 You joined Bolt Nutrition on **${date}**.\n\nThank you for being part of our influencer community! ${userProfile.first_name ? `We're glad to have you, ${userProfile.first_name}!` : ''}`;
            }
            return "📅 Your account creation date is shown in your profile settings. Check 'My Profile' section.";
        }
        
        // Content Guidelines
        if (/\b(guidelines|rules|policy|requirement|disclaimer|terms)\b.*\b(content|post|upload)\b/.test(text)) {
            return "📋 **Content Guidelines:**\n\n✅ **Do:**\n• Tag @boltnutritions\n• Use #BoltNutrition\n• High quality photos/videos\n• Honest reviews\n• Include call-to-action\n\n❌ **Don't:**\n• Misleading claims\n• Poor quality content\n• Competitor mentions\n• Miss mandatory hashtags\n\nViolations may lead to payment rejection or deactivation.";
        }
        
        // Campaign Rates
        if (/\b(rates|rate|pricing|how much|compensation|fee|charge)\b.*\b(campaign|content|post)\b/.test(text)) {
            return "💰 **Standard Campaign Rates:**\n\n• **Reels:** 70% of campaign budget\n• **Stories:** 20% of campaign budget\n• **Static Posts:** 10% of campaign budget\n\n**Bonus:** Top performers get +5-10% extra!\n\n**Payment Timeline:** Monthly, after content verification.";
        }
        
        // Verification Process
        if (/\b(verification|verify|approved|rejected|pending|review)\b.*\b(content|payment|campaign)\b/.test(text)) {
            return "✅ **Verification Process:**\n\n**Content:** 1-2 working days\n• Check status in 'Payment Request'\n• Rejected? Resubmit with corrections\n\n**Profile:** 24-48 hours\n• Email notification on approval\n\n**Campaign Application:** 24-48 hours\n• Coordinator will contact if selected";
        }
        
        // Referral Program
        if (/\b(refer|referral|invite|friend|earn|referral code)\b/.test(text)) {
            if (infCode?.inf_code) {
                return `🤝 **Referral Program:**\n\nYour referral code: **${infCode.inf_code}**\n\n**How it works:**\n• Share your code with friends\n• They get 10% off first order\n• You earn 5% commission on their purchases\n• Track referrals in your dashboard\n\nStart sharing and earn more! 🚀`;
            }
            return "🤝 **Referral Program:**\n\nGet your unique referral code after profile approval. Share with friends and earn 5% commission on their purchases!";
        }
        
        // App & Technical
        if (/\b(app|mobile|android|ios|technical|bug|error|not working|glitch|issue)\b/.test(text)) {
            return "📱 **Technical Support:**\n\n• Bolt Nutrition works best on Chrome, Firefox, Safari\n• Clear cache/cookies if you face issues\n• Dashboard is mobile-responsive\n\n**Still having issues?**\nEmail: social.in@boltnutritions.com\nSubject: Technical Support - Dashboard Issue";
        }
        
        // Farewell & Gratitude
        if (/\b(bye|goodbye|thanks|thank you|appreciate|grateful|cya|see ya)\b/.test(text)) {
            if (userProfile?.first_name) {
                return `You're welcome, ${userProfile.first_name}! 😊 I'm glad I could help. Feel free to reach out anytime. Have an amazing day! 🌟`;
            }
            return "You're welcome! 😊 I'm always here to help with any questions. Have a wonderful day! 🌟";
        }
        
        // Fallback Responses - More varied and helpful
        const fallbacks = [
            "I want to help! Could you tell me which section you need assistance with? (Payments, Campaigns, Profile, Content, Orders, or Technical)",
            
            "Here's what I can help with:\n• INF Code & Profile\n• Campaigns & Content\n• Payments & Payouts\n• Orders & Shipping\n• Technical Issues\n\nJust let me know what you need!",
            
            `For immediate assistance, you can:\n📞 Call: +91 7990387779\n✉️ Email: social.in@boltnutritions.com\n\nOr tell me more about your issue.`,
            
            "I didn't quite catch that. Could you rephrase or specify which dashboard feature you're asking about?",
            
            "Check your dashboard for most information. If you need help with something specific, just ask about:\n• INF code\n• Campaigns\n• Payments\n• Profile updates\n• Content submission",
            
            "The dashboard has all your tools in one place. Need help navigating or with a specific feature?"
        ];
        
        return fallbacks[Math.floor(Math.random() * fallbacks.length)];
    }

    window.testSupportMessage = function(text = "Test message from support") {
        addMessage({
            type: 'support',
            message: text,
            timestamp: new Date().toISOString()
        });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    window.initChatWidget = init;
})();
    
// leaderboard
const API_URL = "https://collab.boltnutritions.com/api/influencers_insta_data";
const REFRESH_INTERVAL = 300000;
const ACTIVE_HOURS = 24;
const RECENT_HOURS = 48;

let currentData = [], refreshInterval;

const $ = id => document.getElementById(id);

const elements = {
    leaderboardBody: $("leaderboard-body"),
    topReach: $("top-reach"),
    totalLikes: $("total-likes"),
    totalComments: $("total-comments")
};

const TOP_IDS = ["first", "second", "third"];

const formatNumber = num =>
    num >= 1e6 ? (num/1e6).toFixed(1)+"M" :
    num >= 1e3 ? (num/1e3).toFixed(1)+"K" :
    num?.toString() || "0";

const hoursDiff = date =>
    date ? (Date.now() - new Date(date)) / 3600000 : Infinity;

const badge = (cls, text) =>
    `<span class="badge bg-${cls} px-2 py-1">${text}</span>`;

const statusBadge = () => badge("success", "Active");

const avatarHTML = (item, size = 45) => {
    const initial = (item.first_name || "U")[0].toUpperCase();
    return `
    <div style="width:${size}px;height:${size}px;">
        <img src="${item.avatar || ''}"
             onerror="this.style.display='none';this.nextElementSibling.style.display='flex';"
             style="width:100%;height:100%;object-fit:cover;border-radius:50%;">
        <div style="
            display:none;
            width:100%;
            height:100%;
            border-radius:50%;
            background:#6c757d;
            color:white;
            align-items:center;
            justify-content:center;
            font-weight:bold;
        ">
            ${initial}
        </div>
    </div>`;
};

const processData = data =>
    data.map(d => ({
        ...d,
        play_count: Number(d.play_count) || 0,
        like_count: Number(d.like_count) || 0,
        comment_count: Number(d.comment_count) || 0,
        first_name: d.first_name || "Unknown"
    }))
    .sort((a,b)=>b.play_count-a.play_count);

function updateTopThree(data){
    TOP_IDS.forEach((id,i)=>{
        const item = data[i];
        if(!item) return;

        const img = $(`${id}-avatar`);
        const name = $(`${id}-name`);
        const reach = $(`${id}-reach`);
        const likes = $(`${id}-likes`);
        const comments = $(`${id}-comments`);

        const initial = (item.first_name || "U")[0].toUpperCase();

        if(img){
            img.style.display = "block"; 
            img.src = item.avatar || "";

            img.onerror = function(){
                this.style.display = "none";

                let fallback = this.parentElement.querySelector(".avatar-fallback");

                if(!fallback){
                    fallback = document.createElement("div");
                    fallback.className = "avatar-fallback d-flex align-items-center justify-content-center rounded-circle position-absolute top-0 start-0 w-100 h-100";
                    fallback.style.background = "#6c757d";
                    fallback.style.color = "white";
                    fallback.style.fontWeight = "bold";
                    fallback.style.fontSize = id === "first" ? "1.5rem" : "1.2rem";
                    fallback.innerText = initial;

                    this.parentElement.appendChild(fallback);
                }
            };
        }

        if(name) name.textContent = item.first_name;
        if(reach) reach.textContent = formatNumber(item.play_count);
        if(likes) likes.textContent = formatNumber(item.like_count);
        if(comments) comments.textContent = formatNumber(item.comment_count);
    });
}

function updateTable(data){
    if(!elements.leaderboardBody) return;

    elements.leaderboardBody.innerHTML =
        data.slice(3,10).map((item,i)=>`
        <tr>
            <td>#${i+4}</td>
            <td class="d-flex align-items-center">
                ${avatarHTML(item)}
                <div class="ms-2" style="font-size: 0.95rem;">${item.first_name}</div>
            </td>
            <td class="text-end">
                <div class="fw-bold">${formatNumber(item.play_count)}</div>
                <small class="text-muted">${item.play_count.toLocaleString("en-IN")}</small>
            </td>
            <td class="text-end">
                ❤️ ${formatNumber(item.like_count)}<br>
                💬 ${formatNumber(item.comment_count)}
            </td>
            <td class="text-end">
                ${statusBadge(item.synced_at)}
            </td>
        </tr>
        `).join("");
}

function updateStats(data){
    const totalViews = data.reduce((s,i)=>s+i.play_count,0);
    const totalLikes = data.reduce((s,i)=>s+i.like_count,0);
    const totalComments = data.reduce((s,i)=>s+i.comment_count,0);

    if(elements.totalLikes)
        elements.totalLikes.textContent = formatNumber(totalLikes);
    if(elements.totalComments)
        elements.totalComments.textContent = formatNumber(totalComments);
}

async function loadLeaderboardData(){
    try{
        elements.leaderboardBody.innerHTML =
            `<tr><td colspan="5" class="text-center">Loading...</td></tr>`;

        const res = await fetch(API_URL,{cache:"no-cache"});
        const json = await res.json();
        if(!json.success) throw Error("No data");
        currentData = processData(json.data);
        updateTopThree(currentData);
        updateTable(currentData);
        updateStats(currentData);
        updateInsights(currentData);
    }catch(e){
        elements.leaderboardBody.innerHTML =
            `<tr><td colspan="5" class="text-center text-danger">Failed to load</td></tr>`;
    }
}

function start(){
    loadLeaderboardData();
    clearInterval(refreshInterval);
    refreshInterval = setInterval(loadLeaderboardData, REFRESH_INTERVAL);
}

document.addEventListener("DOMContentLoaded", start);

function updateInsights(data){
    const card =
        document.getElementById("insights-card");
    const avgReachEl =
        document.getElementById("avg-reach");
    const engRateEl =
        document.getElementById("eng-rate");
    const profileString =
        localStorage.getItem("userProfile");
    if(!profileString){
        avgReachEl.textContent = "0";
        engRateEl.textContent = "0%";
        card.style.filter = "blur(6px)";
        card.style.opacity = "0.6";
        return;
    }
    let profile;
    try{
        profile = JSON.parse(profileString);
    }
    catch(e){
        card.style.filter = "blur(6px)";
        card.style.opacity = "0.6";
        return;
    }
    const selectedName =
        profile.first_name;
    if(!selectedName){
        card.style.filter = "blur(6px)";
        card.style.opacity = "0.6";
        return;
    }

    const filtered =
        data.filter(item =>
            item.first_name &&
            item.first_name.toLowerCase() === selectedName.toLowerCase()
        );

    if(filtered.length === 0){
        avgReachEl.textContent = "0";
        engRateEl.textContent = "0%";
        card.style.filter = "blur(6px)";
        card.style.opacity = "0.6";
        return;
    }

    const totalReach =
        filtered.reduce(
            (sum,i)=>sum+(i.play_count||0),0);
    const totalLikes =
        filtered.reduce(
            (sum,i)=>sum+(i.like_count||0),0);
    const totalComments =
        filtered.reduce(
            (sum,i)=>sum+(i.comment_count||0),0);
    const avgReach =
        Math.round(totalReach / filtered.length);
    const engagementRate =
        totalReach > 0
        ? ((totalLikes + totalComments) / totalReach) * 100
        : 0;
    avgReachEl.textContent =
        formatNumber(avgReach);
    engRateEl.textContent =
        engagementRate.toFixed(2) + "%";
    if(avgReach === 0){
        card.style.filter = "blur(6px)";
        card.style.opacity = "0.6";
    }
    else{
        card.style.filter = "none";
        card.style.opacity = "1";
    }
}
// WALLET AND WITHDRAWAL FUNCTIONALITY
(function () {
  'use strict';

  let currentWalletBalance = 0;
  let withdrawalModal = null;

  const walletCard = document.getElementById('walletCard');
  const walletAmount = document.getElementById('walletAmount');
  const modalWalletAmount = document.getElementById('modalWalletAmount');
  const maxWithdrawSpan = document.getElementById('maxWithdraw');
  const withdrawAmountInput = document.getElementById('withdrawAmount');
  const confirmWithdrawBtn = document.getElementById('confirmWithdrawBtn');
  const withdrawForm = document.getElementById('withdrawForm');
  const withdrawMessage = document.getElementById('withdrawMessage');
  const withdrawalHistoryBody = document.getElementById('withdrawalHistoryBody');
  const withdrawalCount = document.getElementById('withdrawalCount');

  const chargeSpan = document.getElementById('chargeAmount');
  const finalAmountSpan = document.getElementById('finalAmount');

  const FIXED_CHARGE = 4.47;

  // ================= USER =================
  const getUserData = () => {
    try {
      const p = JSON.parse(localStorage.getItem('userProfile') || '{}');
      const u = JSON.parse(localStorage.getItem('user') || '{}');
      return {
        email: p.email || u.email,
        infNo: p.inf_no || u.inf_no || u.id
      };
    } catch {
      return {};
    }
  };

  const formatCurrency = a =>
    '₹' + (parseFloat(a) || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 });

  // ================= WALLET =================
  const updateWalletDisplay = b => {
    const f = formatCurrency(b);

    walletAmount && (walletAmount.textContent = f);
    modalWalletAmount && (modalWalletAmount.textContent = f);
    maxWithdrawSpan && (maxWithdrawSpan.textContent = f);

    if (withdrawAmountInput) {
      withdrawAmountInput.max = b;
      withdrawAmountInput.placeholder = `Max: ${f}`;
    }
  };

  const showMsg = (msg, type = 'danger') => {
    if (!withdrawMessage) return;

    withdrawMessage.textContent = msg;
    withdrawMessage.className = `alert alert-${type} mt-3`;
    withdrawMessage.classList.remove('d-none');

    setTimeout(() => withdrawMessage.classList.add('d-none'), 4000);
  };

  async function fetchWalletBalance() {
    const { email, infNo } = getUserData();
    if (!email && !infNo) return updateWalletDisplay(0);

    try {
      const r = await fetch(`https://collab.boltnutritions.com/api/check-user?email=${email}`);
      const d = await r.json();

      currentWalletBalance = +d?.wallet?.total_balance || 0;
      updateWalletDisplay(currentWalletBalance);

    } catch {
      updateWalletDisplay(0);
    }
  }

  // ================= PAYOUT =================
  async function submitPayoutRequest(amount) {
    const { infNo, email } = getUserData();

    if (!infNo) throw Error('Login again');
    if (!amount || amount < 30) throw Error('Minimum withdrawal amount is ₹30');
    if (amount > currentWalletBalance)
      throw Error(`Insufficient balance. Available: ${formatCurrency(currentWalletBalance)}`);

    const r = await fetch('https://collab.boltnutritions.com/api/wallet-request-payout', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ inf_no: infNo, amount, email })
    });

    const d = await r.json();
    if (!d.success) throw Error(d.message || 'Request failed');

    currentWalletBalance -= amount;
    updateWalletDisplay(currentWalletBalance);
    fetchWithdrawalHistory();

    return d.message || 'Withdrawal requested successfully';
  }

  // ================= HISTORY =================
  async function fetchWithdrawalHistory() {
    const { infNo } = getUserData();
    if (!withdrawalHistoryBody) return;

    try {
      const r = await fetch('https://collab.boltnutritions.com/api/wallet-request-payout');
      const d = await r.json();

      const list = (d.data || [])
        .filter(x => String(x.inf_no) === String(infNo))
        .sort((a, b) => new Date(b.request_date) - new Date(a.request_date));

      withdrawalCount && (withdrawalCount.textContent = `${list.length} Requests`);

      if (!list.length) {
        withdrawalHistoryBody.innerHTML =
          `<tr><td colspan="4" class="text-center py-4">No history</td></tr>`;
        return;
      }

      withdrawalHistoryBody.innerHTML = list.map(x => {

        const statusMap = {
          approved: 'success',
          rejected: 'danger',
          pending: 'warning'
        };

        const status = (x.status || 'pending').toLowerCase();
        const cls = statusMap[status] || 'secondary';

        const date = new Date(x.request_date).toLocaleDateString('en-IN', {
          day: '2-digit',
          month: 'short',
          year: 'numeric'
        });

        return `
        <tr>
          <td>${date}</td>
          <td>${formatCurrency(x.requested_amount)}</td>
          <td class="fw-bold">
            ${formatCurrency(x.approved_amount || 0)}<span class="text-danger" style="margin-left:2px;">Dr</span>
          </td>
          <td><span class="badge bg-${cls}">${status}</span></td>
        </tr>`;
      }).join('');

    } catch {
      withdrawalHistoryBody.innerHTML =
        `<tr><td colspan="4" class="text-danger text-center">Error loading</td></tr>`;
    }
  }

  // ================= INIT =================
  function init() {
    if (!walletCard) return;

    const modalEl = document.getElementById('withdrawModal');
    walletCard.onclick = async () => {
      await fetchWalletBalance();
      await fetchWithdrawalHistory();

      withdrawForm?.reset();
      withdrawMessage?.classList.add('d-none');

      chargeSpan.textContent = '0.00';
      finalAmountSpan.textContent = '0.00';

      if (window.bootstrap && modalEl) {
        withdrawalModal = new bootstrap.Modal(modalEl);
        withdrawalModal.show();
      }
    };

    // BANK DETAILS AUTO-FILL
    modalEl?.addEventListener('show.bs.modal', function () {

    const bankName = document.getElementById('displayBankName')?.value || '-';
    const accNumber = document.getElementById('displayAccNumber')?.value || '-';
    const maskedAcc = accNumber !== '-' ? 'XXXXXX' + accNumber.slice(-4) : '-';

    document.getElementById('modalBankName').innerText = bankName;
    document.getElementById('modalAccNumber').innerText = maskedAcc;
    if (!accNumber || accNumber === '-') {
        confirmWithdrawBtn.disabled = true;
        confirmWithdrawBtn.innerText = '⚠️ Add Bank Details First';
    } else {
        confirmWithdrawBtn.disabled = false;
        confirmWithdrawBtn.innerText = '🚀 Request Withdrawal';
    }
    });

    // SUBMIT
    confirmWithdrawBtn.onclick = async () => {
      const amt = +withdrawAmountInput.value;

      if (!amt) return showMsg('Enter amount');
      if (amt < 30) return showMsg('Minimum withdrawal is ₹30');

      confirmWithdrawBtn.disabled = true;
      confirmWithdrawBtn.innerHTML = 'Processing...';

      try {
        const charge = FIXED_CHARGE;
        const finalAmt = Math.max(0, amt - charge);

        await submitPayoutRequest(amt);

        showMsg(`Charges: ₹${charge.toFixed(2)} | You receive: ₹${finalAmt.toFixed(2)}`, 'success');

        setTimeout(() => withdrawalModal?.hide(), 2000);

      } catch (e) {
        showMsg(e.message);
      }

      confirmWithdrawBtn.disabled = false;
      confirmWithdrawBtn.innerHTML = '🚀 Request Withdrawal';
    };

    // LIVE CALCULATION
    withdrawAmountInput.oninput = function () {
      const amount = +this.value || 0;

      const charge = amount > 0 ? FIXED_CHARGE : 0;
      const finalAmount = Math.max(0, amount - charge);

      chargeSpan.textContent = charge.toFixed(2);
      finalAmountSpan.textContent = finalAmount.toFixed(2);

      this.classList.toggle('is-invalid', amount > currentWalletBalance);
    };

    fetchWalletBalance();
    fetchWithdrawalHistory();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

})();